{
  "cardRecord": {
    "expand": "Expandir registro",
    "collapse": "Recolher registro"
  },
  "reservedMaterialReview": {
    "operation": "Operação {{number}}",
    "reserved": "Reserva pendente: {{amount}}",
    "quantity": "Quantidade a consumir de {{code}}",
    "refresh": "Volte ao painel e abra a revisão para atualizar o saldo e o vínculo da reserva."
  },
  "accessRestricted": {
    "title": "Acesso restrito",
    "body": "Seu papel não permite acessar esta página. Fale com o administrador da sua conta."
  },
  "notFound": {
    "title": "Página não encontrada",
    "body": "O endereço não corresponde a uma página disponível. Volte ao chat para continuar.",
    "back": "Voltar ao chat"
  },
  "symptomPrompt": {
    "title": "SINTOMA",
    "question": "O que aconteceu com o equipamento? Descreva com as suas palavras.",
    "placeholder": "Ex.: vazamento de óleo no selo da bomba",
    "helper": "Escreva o problema como você contaria a um colega.",
    "submitLabel": "Enviar"
  },
  "procedureAuthoring": {
    "title": "CRIAR PROCEDIMENTO",
    "escolha": {
      "greeting": "Olá, {{name}}! O que você quer fazer?"
    },
    "rascunhos": {
      "title": "Meus rascunhos",
      "empty": "Você não tem rascunhos.",
      "resume": "Continuar",
      "steps_one": "{{count}} passo",
      "steps_other": "{{count}} passos"
    },
    "equipamento": {
      "title": "Equipamento",
      "searchLabel": "Buscar por código ou nome",
      "searchButton": "Buscar",
      "select": "Selecionar",
      "empty": "Nenhum equipamento encontrado."
    },
    "pontoDePartida": {
      "question_one": "Usar o passo simples do plano deste equipamento?",
      "question_other": "Usar os {{count}} passos simples do plano deste equipamento?"
    },
    "cabecalho": {
      "title": "Cabeçalho",
      "name": "Nome do procedimento",
      "namePlaceholder": "Ex.: Troca do selo da bomba",
      "objective": "Objetivo",
      "safety": "Segurança (bloqueio, EPI)",
      "safetyPlaceholder": "Opcional",
      "duration": "Duração (minutos)",
      "crew": "Equipe"
    },
    "passo": {
      "title": "Passo {{index}}",
      "titleOf": "Passo {{index}} de {{total}}",
      "text": "O que fazer neste passo",
      "textPlaceholder": "Ex.: Desligue e bloqueie a bomba antes de abrir a tampa",
      "camera": "Câmera",
      "importImage": "Importar imagem",
      "photos": "Fotos do passo",
      "photoItem": "Foto {{n}}",
      "removePhoto": "Remover foto {{n}}",
      "uploading": "Enviando foto...",
      "photoFailed": "Não foi possível enviar a foto.",
      "photoTooLarge": "A foto ficou maior que 1 MB. Tente outra."
    },
    "revisao": {
      "title": "Revisão",
      "summary_one": "{{count}} passo, {{photos}} com foto",
      "summary_other": "{{count}} passos, {{photos}} com foto",
      "editStep": "Editar passo {{n}}",
      "editLabel": "Editar um passo"
    },
    "vinculo": {
      "title": "Vincular equipamentos",
      "question": "Vincular agora a um ou mais equipamentos?",
      "none": "Nenhum equipamento disponível."
    },
    "pausado": {
      "title": "Rascunho salvo",
      "body": "Para continuar: /criar-procedimento e Continuar rascunho."
    },
    "concluido": {
      "title": "Procedimento",
      "steps_one": "{{count}} passo",
      "steps_other": "{{count}} passos",
      "photos_one": "{{count}} foto",
      "photos_other": "{{count}} fotos",
      "equipment_one": "{{count}} equipamento vinculado",
      "equipment_other": "{{count}} equipamentos vinculados",
      "statusCreated": "Rascunho",
      "statusReleased": "Publicado"
    }
  },
  "procFoto": {
    "coluna": "Foto",
    "camera": "Câmera",
    "importar": "Importar imagem",
    "pular": "Pular",
    "adicionar": "Adicionar foto",
    "naoConsigo": "Não consigo fotografar",
    "motivoLabel": "Motivo para não fotografar",
    "motivoPlaceholder": "Ex.: sem luz no local",
    "enviando": "Enviando foto…",
    "erroGrande": "A foto ficou grande demais mesmo comprimida. Tire outra com menos detalhe.",
    "erroIlegivel": "Formato não suportado. Use uma foto JPG ou PNG.",
    "erroEnvio": "Não foi possível enviar a foto. Tente novamente.",
    "previa": "Pré-visualização da foto",
    "remover": "Remover foto",
    "ampliar": "Ampliar foto",
    "fechar": "Fechar",
    "fotoAlt": "Foto anexada",
    "carregando": "Carregando foto…",
    "indisponivel": "Foto indisponível",
    "politica": {
      "title": "FOTO NA NOTA E NA ORDEM",
      "intro": "Escolha quando a foto é pedida. A mudança vale para toda a empresa.",
      "notificacao": "Nota",
      "ordem": "Ordem de serviço",
      "off": "Desligada",
      "optional": "Opcional",
      "required": "Obrigatória",
      "salvar": "Salvar política",
      "somenteLeitura": "Só administradores podem mudar esta política.",
      "salvo": "Política de foto salva"
    }
  },
  "admin": {
    "title": "Painel Administrativo",
    "subtitle": "Visão operacional da sua operação.",
    "loading": "Carregando dados administrativos…",
    "forbidden": "Você não tem permissão para acessar esta página.",
    "error": "Não foi possível carregar os dados administrativos. Tente novamente.",
    "metrics": {
      "totalEquipments": "Total de equipamentos",
      "activeEquipments": "Equipamentos ativos",
      "openWorkOrders": "Ordens de serviço abertas",
      "openNotifications": "Notificações abertas",
      "criticalNotifications": "Notificações críticas",
      "activeMaintPlans": "Planos de manutenção ativos",
      "completedWoThisMonth": "OS concluídas no mês",
      "pmc": "Aderência à manutenção planejada (%)",
      "totalPlants": "Plantas",
      "totalLocations": "Localizações",
      "goToSection": "Ver {{section}}",
      "draftMaintPlans": "Planos em rascunho"
    },
    "tabs": "Seções administrativas",
    "tabDashboard": "Painel",
    "tabEntities": "Navegador de entidades",
    "backToConversation": "Voltar à conversa",
    "sectionMenu": "Menu de seções",
    "sections": {
      "dashboard": "Painel",
      "equipment": "Equipamentos",
      "plants": "Plantas",
      "locations": "Localizações",
      "materials": "Materiais",
      "workOrders": "Ordens de serviço",
      "maintPlans": "Planos de manutenção",
      "notifications": "Notificações",
      "proposals": "Propostas (IA)",
      "auditLog": "Log de auditoria",
      "sessions": "Sessões",
      "skills": "Skills",
      "inventoryTurnover": "Giro de estoque",
      "recursos": "Recursos",
      "specialties": "Especialidades",
      "config": "Configuração",
      "i18n": "Idiomas",
      "entities": "Navegador de entidades",
      "flowGraph": "Fluxo do Axis"
    },
    "flowGraph": {
      "subtitle": "Grafo do fluxo de onboarding: cada nó é uma tela, decisão ou raciocínio do Axis, e cada aresta é uma transição determinística do fluxo.",
      "hint": "Passe o mouse em um nó para iluminar as conexões dele. Clique para o Axis retomar o percurso a partir dali. Arraste para reorganizar.",
      "canvasLabel": "Grafo do fluxo de onboarding do Axis",
      "legend": {
        "render": "Tela (mostra algo)",
        "decision": "Decisão (o usuário escolhe)",
        "agentic": "Raciocínio do Axis (pesquisa)",
        "pending": "Na fila (a construir)"
      },
      "zones": {
        "onboarding": "Onboarding",
        "operations": "Operação do dia a dia"
      }
    },
    "proposals": {
      "subtitle": "Propostas geradas por IA aguardando revisão.",
      "filterStatus": "Filtrar por status",
      "empty": "Nenhuma proposta encontrada.",
      "showItems": "Ver itens",
      "hideItems": "Ocultar itens",
      "approve": "Aprovar",
      "reject": "Rejeitar",
      "status": {
        "all": "Todos os status",
        "pending": "Pendente",
        "approved": "Aprovada",
        "partial": "Parcial",
        "rejected": "Rejeitada",
        "expired": "Expirada",
        "auto_approved": "Aprovada automaticamente",
        "executed": "Executada",
        "unknown": "Desconhecido"
      },
      "type": {
        "field_update": "Atualizar campo",
        "create_notification": "Criar notificação",
        "create_work_order": "Criar ordem de serviço",
        "horizon_refill": "Recarregar horizonte",
        "unknown": "Desconhecido"
      },
      "col": {
        "created": "Criada em",
        "type": "Tipo",
        "items": "Itens",
        "field": "Campo",
        "current": "Atual",
        "proposed": "Proposto",
        "confidence": "Confiança"
      }
    },
    "auditLog": {
      "aiActor": "Assistente de IA",
      "integrationActor": "Integração",
      "unknownActor": "Origem não identificada",
      "actions": {
        "create": "Criação",
        "update": "Atualização",
        "delete": "Exclusão",
        "approve": "Aprovação",
        "reject": "Rejeição",
        "status_change": "Alteração de status",
        "state_transition": "Progresso do atendimento",
        "flow_run_node_persisted": "Etapa da conversa registrada",
        "unknown": "Outra ação"
      },
      "systemActor": "Processo do sistema",
      "unavailableActor": "Usuário indisponível",
      "subtitle": "Trilha de auditoria das alterações deste tenant.",
      "exportCsv": "Exportar CSV",
      "filterEntity": "Filtrar por entidade",
      "filterAction": "Filtrar por ação",
      "allEntities": "Todas as entidades",
      "allActions": "Todas as ações",
      "dateFrom": "Data inicial",
      "dateTo": "Data final",
      "col": {
        "when": "Quando",
        "actor": "Autor",
        "entity": "Entidade",
        "action": "Ação",
        "diff": "Alteração"
      }
    },
    "sessions": {
      "subtitle": "Status do gateway de skills e sessões ativas.",
      "online": "Gateway online",
      "offline": "Gateway offline",
      "skillsCount": "{{count}} skills carregadas",
      "empty": "Nenhuma sessão ativa.",
      "col": {
        "id": "ID",
        "channel": "Canal",
        "user": "Usuário",
        "lastActivity": "Última atividade",
        "status": "Status"
      }
    },
    "skills": {
      "subtitle": "Skills carregadas pelo gateway.",
      "empty": "Nenhuma skill carregada.",
      "noDescription": "Sem descrição"
    },
    "inventory": {
      "subtitle": "Materiais em excesso ordenados por capital imobilizado.",
      "selectPlant": "Selecione uma planta…",
      "searchPlaceholder": "código ou descrição",
      "choosePlantHint": "Selecione uma planta para ver o giro de estoque.",
      "empty": "Nenhum material em excesso nesta planta.",
      "excess": "Excesso",
      "col": {
        "code": "Código",
        "description": "Descrição",
        "unit": "Unidade",
        "currentStock": "Estoque atual",
        "available": "Disponível",
        "maxStock": "Estoque máx.",
        "excessQty": "Excesso",
        "capital": "Capital imobilizado",
        "status": "Status"
      }
    },
    "recursos": {
      "subtitle": "Quadro de recursos (técnicos) e sua capacidade.",
      "searchPlaceholder": "nome, email ou matrícula",
      "filterPlant": "Filtrar por planta",
      "filterRole": "Filtrar por função",
      "allPlants": "Todas as plantas",
      "allRoles": "Todas as funções",
      "empty": "Nenhum recurso encontrado.",
      "col": {
        "name": "Nome",
        "role": "Função",
        "team": "Equipe",
        "plant": "Planta",
        "email": "Email",
        "personnel": "Matrícula",
        "weekly": "Capacidade semanal",
        "daily": "Capacidade diária"
      }
    },
    "specialties": {
      "title": "Especialidades de Manutenção",
      "subtitle": "Gerencie as disciplinas técnicas do seu time. Cada equipe é vinculada a uma especialidade.",
      "columns": {
        "name": "Nome",
        "slug": "Código",
        "status": "Status",
        "isDefault": "Padrão"
      },
      "namePlaceholder": "Nome da especialidade",
      "addButton": "Adicionar",
      "editButton": "Editar",
      "saveButton": "Salvar",
      "cancelButton": "Cancelar",
      "deleteButton": "Excluir",
      "deactivateButton": "Desativar",
      "activateButton": "Ativar",
      "showInactive": "Mostrar inativas",
      "active": "Ativa",
      "inactive": "Inativa",
      "isDefault": "Sistema",
      "confirmDelete": "Excluir esta especialidade? Equipes vinculadas impedem a exclusão.",
      "empty": "Nenhuma especialidade ativa. Crie a primeira.",
      "errors": {
        "inUse": "Em uso por {{count}} equipe(s). Desative em vez de excluir.",
        "isDefault": "Especialidades padrão do sistema não podem ser excluídas. Desative-as.",
        "saveFailed": "Erro ao salvar. Tente novamente.",
        "loadFailed": "Erro ao carregar especialidades."
      },
      "seeds": {
        "mechanical": "Mecânica",
        "electrical": "Elétrica",
        "instrumentation": "Instrumentação",
        "lubrication": "Lubrificação",
        "operator": "Operador",
        "general": "Geral"
      }
    },
    "config": {
      "subtitle": "Parâmetros do harness (whitelist).",
      "searchPlaceholder": "key ou descrição",
      "filterScope": "Filtrar por escopo",
      "allScopes": "Todos os escopos",
      "saved": "Salvo",
      "reset": "Restaurado",
      "resetBtn": "Restaurar",
      "saveFailed": "Falha ao salvar.",
      "invalidJson": "JSON inválido.",
      "confirmReset": "Restaurar este parâmetro para o valor padrão?",
      "default": "Default (não sobrescrito)",
      "overridden": "Sobrescrito",
      "overriddenBy": "Atualizado por {{name}}"
    },
    "reset": {
      "reveal": "Zona de risco",
      "warning": "Isto APAGA toda a base (todos os dados) e recria do zero. Ação irreversível.",
      "passwordLabel": "Senha de reset",
      "confirm": "Resetar base",
      "confirmAgain": "Confirmar reset, clique de novo",
      "running": "Resetando a base…",
      "success": "Base resetada com sucesso.",
      "wrongPassword": "Senha incorreta.",
      "cooldown": "Aguarde alguns segundos antes de resetar de novo.",
      "forbidden": "Reset não permitido neste ambiente.",
      "error": "Falha ao resetar a base."
    },
    "dangerZone": {
      "typedLabel": "Digite {{phrase}} para confirmar",
      "unavailable": "Esta ação está disponível somente para o Owner ou o Admin da empresa numa base de teste autorizada.",
      "title": "Zona de perigo",
      "buttonLabel": "Resetar base agora",
      "warning": "Esta ação apaga os dados operacionais da empresa atual no ambiente {{environment}} e recria sua base. Contas, autenticação, auditoria e dados de outras empresas são preservados. Irreversível.",
      "confirm1Warning": "Confirmar a limpeza dos dados operacionais da empresa atual em {{environment}}? Esta ação não pode ser desfeita.",
      "proceedToPassword": "Sim, prosseguir",
      "passwordLabel": "Digite a senha de reset da base",
      "passwordPlaceholder": "Senha de reset",
      "confirmButton": "Confirmar reset total",
      "submitting": "Resetando…",
      "cancel": "Cancelar",
      "successToast": "Base {{environment}} resetada com sucesso.",
      "wrongSecret": "Senha de reset incorreta.",
      "cooldown": "Aguarde alguns segundos antes de resetar de novo.",
      "genericError": "Falha ao resetar a base. Tente novamente.",
      "noPermission": "Só o Owner ou o Admin da empresa podem resetar a base.",
      "locked": "Senha de reset errada 3 vezes. O reset fica bloqueado por {{minutes}} min.",
      "verificationUnavailable": "Não foi possível conferir a senha de reset agora. Tente de novo em alguns minutos.",
      "reauthExpired": "A confirmação expirou. Digite a senha de reset de novo.",
      "sessionExpired": "Sua sessão expirou. Entre de novo e repita o reset.",
      "setupTitle": "Defina a senha de reset da base",
      "setupHint": "Antes do primeiro reset, defina aqui uma senha só para esta ação. Ela é separada do login, então vale também para quem entra pelo Google. Mínimo de {{min}} caracteres.",
      "newPasswordLabel": "Nova senha de reset",
      "confirmPasswordLabel": "Repita a nova senha de reset",
      "saveSetup": "Salvar senha de reset",
      "saving": "Salvando…",
      "setupSaved": "Senha de reset salva. Agora você já pode resetar a base.",
      "tooShort": "A senha de reset precisa ter pelo menos {{min}} caracteres.",
      "mismatch": "As duas senhas não são iguais.",
      "resetPasswordNotSet": "Esta base ainda não tem senha de reset. Defina a senha aqui mesmo, nesta tela.",
      "alreadySet": "A senha de reset já foi definida. Para trocar, informe a senha atual.",
      "changeTitle": "Trocar a senha de reset",
      "currentPasswordLabel": "Senha de reset atual",
      "saveChange": "Trocar senha de reset",
      "changeSaved": "Senha de reset trocada.",
      "resetNotApplied": "A limpeza não foi aplicada: os dados foram preservados. Após corrigir a causa, digite a senha de reset novamente para confirmar outra tentativa.",
      "resetPartial": "O servidor informou uma limpeza possivelmente parcial. Confira o estado antes de iniciar outra limpeza.",
      "resetOutcomeUnknown": "Não foi possível confirmar o resultado da limpeza. Confira o estado antes de iniciar outra limpeza.",
      "retryButton": "Confirmar nova tentativa de limpeza",
      "serverTimestamp": "Horário informado pelo servidor:",
      "checkStatus": "Verificar estado da limpeza",
      "checkingStatus": "Conferindo estado…",
      "resetStillRunning": "Uma limpeza ainda está em andamento nesta empresa. Aguarde e consulte o estado novamente.",
      "resetStatusUnavailable": "Não foi possível conferir o estado agora. Nenhuma nova limpeza foi iniciada.",
      "operationReference": "Referência da operação:",
      "resetMaintenanceUnavailable": "A limpeza segura desta base está temporariamente indisponível. A configuração do ambiente precisa ser corrigida; nenhuma nova limpeza será iniciada enquanto isso.",
      "newCleanupWarning": "O resultado anterior permanece sem confirmação de sucesso. Iniciar outra limpeza exige uma nova confirmação e senha; isso não confirma nem retoma a operação anterior.",
      "startNewCleanup": "Iniciar uma nova limpeza",
      "resetAlreadyRunning": "Já existe uma limpeza em andamento nesta empresa. Consulte o estado antes de iniciar outra."
    },
    "i18n": {
      "subtitle": "Configuração de idiomas do harness.",
      "supportedLanguages": "Idiomas suportados",
      "defaultLanguage": "Idioma padrão",
      "fallbackLanguage": "Idioma de fallback",
      "detectionStrategy": "Estratégia de detecção",
      "allowUserOverride": "Permitir override do usuário",
      "addLang": "Adicionar",
      "removeLang": "Remover {{lang}}",
      "invalidTag": "Tag BCP-47 inválida.",
      "saved": "Salvo",
      "saveFailed": "Falha ao salvar."
    },
    "grid": {
      "search": "Buscar",
      "searchPlaceholder": "Buscar registros…",
      "filters": "Filtros",
      "filtersGroup": "Filtros por coluna",
      "filterPlaceholder": "Valor…",
      "filterBy": "Filtrar por {{field}}",
      "columns": "Colunas",
      "compact": "Compacto",
      "comfortable": "Confortável",
      "refresh": "Atualizar",
      "export": "Exportar Excel",
      "exporting": "Exportando…",
      "exportFailed": "Falha ao exportar. Tente novamente.",
      "exportTooLarge": "Linhas demais para exportar, refine o filtro e tente novamente.",
      "clearAll": "Limpar tudo",
      "removeFilter": "Remover filtro de {{field}}",
      "tableCaption": "Registros da entidade",
      "expandColumn": "Expandir linha",
      "expandRow": "Expandir linha",
      "collapseRow": "Recolher linha",
      "copyId": "Copiar ID",
      "copied": "Copiado",
      "pagination": "Paginação",
      "totalRows": "Total de registros:",
      "prev": "Anterior",
      "next": "Próximo",
      "jumpToPage": "Ir para a página",
      "ofPages": "de {{count}}",
      "empty": "Nenhum registro corresponde aos filtros atuais.",
      "loadError": "Não foi possível carregar os registros.",
      "retry": "Tentar novamente",
      "schemaError": "Não foi possível carregar o schema do modelo.",
      "selectModel": "Selecione um modelo para navegar.",
      "searchModels": "Buscar modelos…",
      "modelList": "Modelos"
    },
    "workOrderDetail": {
      "descriptionTitle": "Descrição",
      "longTextLabel": "Texto longo",
      "notificationTitle": "Notificação Vinculada",
      "notificationCol": {
        "id": "ID",
        "description": "Descrição"
      },
      "operationsTitle": "Operações ({{count}})",
      "operationsEmpty": "Nenhuma operação cadastrada",
      "operationsCol": {
        "seq": "Seq",
        "description": "Descrição",
        "plannedDuration": "Duração Plan.",
        "technician": "Técnico",
        "status": "Status"
      },
      "componentsTitle": "Materiais ({{count}})",
      "componentsEmpty": "Nenhum componente vinculado",
      "componentsCol": {
        "material": "Material",
        "description": "Descrição",
        "qty": "Qtd",
        "unit": "Unid",
        "origin": "Origem"
      },
      "needsPurchase": "Compra",
      "fromStock": "Estoque"
    }
  },
  "common": {
    "appName": "AxiomGO",
    "tagline": "AI Guidance & Maintenance Orchestration",
    "send": "Enviar",
    "cancel": "Cancelar",
    "confirm": "Confirmar",
    "close": "Fechar",
    "loading": "Carregando...",
    "retry": "Tentar novamente",
    "settings": "Configurações",
    "help": "Ajuda",
    "yes": "Sim",
    "no": "Não",
    "delete": "Excluir"
  },
  "chat": {
    "composerRecovery": {
      "storageFailed": "Não foi possível preparar o envio. O texto foi mantido. Tente novamente.",
      "available": "Texto do envio anterior disponível para revisão.",
      "restore": "Recuperar texto"
    },
    "expandCard": {
      "expand": "Expandir card",
      "expandedBadge": "Card aberto em tela cheia",
      "title": {
        "equipment_search": "Resultado do equipamento",
        "import": "Importação",
        "kpi": "Indicadores",
        "plan_edit": "Plano de manutenção: revisar",
        "preventive_draft": "Plano preventivo: rascunho",
        "proposal": "Proposta",
        "resource_allocation": "Alocação de recursos",
        "task_materials": "Materiais por tarefa",
        "web_search": "Sugestão de plano, montada pelo Axis"
      }
    },
    "placeholder": "Pergunte sobre ativos, falhas, planos ou ordens…",
    "axisKPanelSubtitle": "Descreva um problema ou peça uma análise técnica",
    "placeholders": [
      "Digite / para ver o que eu posso fazer",
      "Cadastre um equipamento: tag, fabricante e modelo",
      "Monte uma sugestão de plano a partir do manual do fabricante",
      "Pergunte: por que o compressor GA37 está vibrando?"
    ],
    "placeholderByFlow": {
      "corretiva": "Descreva a falha e eu abro a ordem de serviço",
      "preventiva": "Ajuste intervalos ou tarefas do plano de manutenção"
    },
    "commandPalette": {
      "notifications": "Listar notificações",
      "unavailable": "Comandos indisponíveis",
      "empty": "Nenhum comando. Envie como texto"
    },
    "disclaimer": "O AxiomGO pode cometer erros. Confirme ações antes de executar.",
    "newConversation": "Nova conversa",
    "copyConversation": "Copiar conversa",
    "copyConversationRoleUser": "Você",
    "history": "Histórico",
    "typing": "Digitando...",
    "noConversations": "Nenhuma conversa ainda",
    "mockResponse": "recebeu sua mensagem. Integração com o Motor está pendente.",
    "reconnectAttempt": "tentativa {{count}}",
    "suggestedActions": "Ações sugeridas",
    "assistant_avatar_alt": "AxiomGO",
    "stopProcessing": "Parar",
    "cancel": "Cancelar",
    "turnTimedOut": "A resposta demorou demais. Tente novamente.",
    "turnGaveUp": "A resposta não chegou ao fim. Nada do que você já tinha foi perdido: toque em \"Tentar novamente\" para retomar de onde parou.",
    "inactivity": {
      "pausedAt": "Pausado por inatividade · {{time}}.",
      "saved": "Sua planilha continua salva.",
      "resume": "Retomar"
    },
    "copyMessage": "Copiar mensagem",
    "retryMessage": "Tentar novamente",
    "recommended": "Recomendado",
    "writeYourOwn": "ou escreva você mesmo",
    "criticalConfirmation": {
      "materialConsumption": {
        "title": "Confirmar consumo de material",
        "confirm": "Confirmar consumo",
        "prompt": "Confirma a baixa de {{items}}?",
        "promptWithOrder": "Confirma a baixa de {{items}} na ordem {{order}}?"
      },
      "workOrderClosure": {
        "title": "Confirmar encerramento da ordem",
        "confirm": "Confirmar encerramento"
      },
      "yes": "Sim",
      "no": "Não",
      "confirmMessage": "Sim, confirmo.",
      "expiredNote": "A confirmação expirou. Peça a ação novamente.",
      "unboundNote": "Não consegui identificar a conversa desta confirmação. Peça a ação novamente.",
      "cancelledNote": "Ação cancelada.",
      "ariaLabel": "Confirmação de ação crítica",
      "closeNoteLabel": "Nota de encerramento",
      "closeNotePlaceholder": "Descreva o que foi realizado…",
      "closeNoteCounter": "{{count}} caracteres",
      "closeNoteCounterMinimum": "{{count}} de {{minChars}} caracteres mínimos",
      "wandLabel": "Melhorar nota",
      "wandPending": "Melhorando nota…"
    },
    "deliveryFailed": "Falha ao enviar, toque em \"Tentar novamente\"",
    "deliveryFailedShort": "Falhou",
    "emptyResponseHint": "Essa resposta não veio dessa vez. Toque em \"Tentar novamente\" ou reformule a pergunta.",
    "actionFailure": {
      "notCompleted": "não foi concluída"
    },
    "reasoning": {
      "thinking": "Pensando...",
      "done": "Detalhes da resposta",
      "failed": "Processamento interrompido",
      "stalledHint": "Processando, só um instante...",
      "error": "A resposta foi interrompida.",
      "retry": "Repetir"
    },
    "message": {
      "renderError": {
        "title": "Não consegui desenhar esta resposta",
        "body": "O conteúdo desta mensagem veio corrompido. O restante da conversa continua funcionando. Toque em \"Tentar novamente\" para reenviar sua última mensagem.",
        "retry": "Tentar novamente"
      }
    },
    "onboardingWaiting": {
      "preparing": "Preparando suas boas-vindas..."
    },
    "onboardingUploadCard": {
      "attachButton": "Anexar planilha",
      "dropHint": "ou arraste o arquivo aqui",
      "sent": "Planilha enviada"
    },
    "searchWait": {
      "background": "Você pode continuar em outras conversas. A pesquisa segue em segundo plano e avisaremos quando terminar.",
      "title": "Pesquisa técnica em andamento",
      "body": "O Axis está consultando fontes na web: manuais de fabricante e recomendações de manutenção para fundamentar a resposta.",
      "duration": "A busca e a montagem do plano podem levar até 5 minutos.",
      "elapsed": "{{elapsed}} decorridos"
    },
    "planTasksPartial": {
      "region": "Tarefas do plano em validação",
      "badge": "Em validação",
      "counter_one": "{{count}} tarefa",
      "counter_other": "{{count}} tarefas",
      "note": "Prévia enquanto o plano é montado. Nada foi salvo; o plano final substitui esta tabela."
    },
    "progress": {
      "searching": "Buscando informações na web...",
      "sources": "Analisando fontes encontradas...",
      "analyzing": "Processando com inteligência artificial...",
      "tools": "Executando ação...",
      "generating": "Gerando resposta...",
      "reasoning": "Raciocinando..."
    },
    "contextMeter": {
      "label": "Uso de contexto",
      "tooltip": "{{tokensK}}/{{limitK}}K tokens",
      "warning": "Conversa próxima do limite, considere começar uma nova"
    },
    "fallbackActions": {
      "ariaLabel": "Próximos passos sugeridos",
      "welcome": {
        "cadastrarEquipamentos": {
          "label": "Cadastrar meus equipamentos",
          "value": "quero cadastrar meus equipamentos"
        },
        "montarPlano": {
          "label": "Montar plano de manutenção",
          "value": "quero montar um plano de manutenção"
        },
        "comoFunciona": {
          "label": "Como funciona o gerenciamento?",
          "value": "explique como gerencio execução de manutenção"
        }
      },
      "equipment": {
        "montarPlanoEsses": {
          "label": "Montar plano para esses equipamentos",
          "value": "monte um plano para meus equipamentos cadastrados"
        }
      },
      "equipmentTag": {
        "assumirDefault": {
          "label": "Assumir Tag {{tag}}",
          "value": "assumir tag {{tag}}"
        },
        "assumirShort": {
          "label": "Assumir Tag {{tag}}",
          "value": "assumir tag {{tag}}"
        },
        "preferencia": {
          "label": "Registrar Tag de minha preferência",
          "value": "quero registrar uma tag de minha preferência"
        },
        "outraOpcao": {
          "label": "Sugerir outra opção aleatória",
          "value": "sugira outra opção de tag"
        }
      },
      "plan": {
        "iniciarExecucao": {
          "label": "Iniciar execução do plano",
          "value": "iniciar execução do plano"
        },
        "editarTarefas": {
          "label": "Editar tarefas do plano",
          "value": "quero editar as tarefas do plano"
        },
        "adicionarEquipamentos": {
          "label": "Adicionar mais equipamentos ao plano",
          "value": "adicionar equipamentos ao plano"
        }
      },
      "kpi": {
        "verDashboard": {
          "label": "Ver dashboard completo",
          "value": "mostre o dashboard de KPIs"
        },
        "priorizarMelhorias": {
          "label": "Quais melhorias priorizar?",
          "value": "quais melhorias devo priorizar com base nos KPIs?"
        },
        "configurarAlertas": {
          "label": "Configurar alertas de KPI",
          "value": "quero configurar alertas para KPIs críticos"
        }
      },
      "searchFailure": {
        "cadastrarManual": {
          "label": "Cadastrar com dados básicos",
          "value": "pode cadastrar o equipamento com os dados básicos que já temos"
        },
        "tentarBuscaAlternativa": {
          "label": "Tentar busca alternativa",
          "value": "tenta a pesquisa com termos alternativos"
        },
        "abrirSemCadastro": {
          "label": "Abrir sem cadastro completo",
          "value": "pode abrir a notificação com os dados básicos mesmo, sem o cadastro completo"
        }
      }
    },
    "attachment": {
      "ariaLabel": "Anexo: {{filename}}, {{size}}",
      "sizeKb": "{{size}} KB",
      "sizeMb": "{{size}} MB"
    },
    "machineEnvelope": {
      "importProgress": "Importação em andamento: {{imported}} de {{total}} linhas. Aviso o senhor quando terminar.",
      "generic": "Recebi uma atualização do sistema que esta versão da tela ainda não sabe mostrar. A operação seguiu normalmente."
    },
    "renameFailed": "Não deu para renomear a conversa. O nome anterior foi mantido.",
    "scrollToBottom": "Rolar até o fim",
    "chips": {
      "grupo": {
        "indicador": "Indicadores",
        "auditoria": "Auditoria dos dados"
      }
    }
  },
  "settings": {
    "sections": "Configurações da conta",
    "title": "Preferências",
    "lang": {
      "label": "Idioma"
    },
    "theme": {
      "label": "Tema",
      "shine": "Shine",
      "night": "Night"
    },
    "notifications": {
      "label": "Avisos do sistema",
      "enable": "Ativar avisos do sistema",
      "enabled": "Avisos do sistema ativados",
      "denied": "Avisos bloqueados no navegador. Mude nas configurações do aparelho.",
      "unsupported": "Este navegador não suporta avisos do sistema"
    }
  },
  "sidebar": {
    "userMenu": {
      "open": "Abrir menu da conta de {{name}}",
      "account": "Minha conta"
    },
    "models": "Modelos",
    "settings": "Configurações",
    "openSettings": "Abrir preferências",
    "adminDashboard": "Painel administrativo",
    "toggle": "Alternar barra lateral",
    "toggleTheme": "Alternar tema",
    "language": "Idioma",
    "collapse": "Recolher barra lateral",
    "expand": "Expandir barra lateral",
    "newConversation": "Nova Conversa",
    "dashboard": "Dashboard",
    "plans": "Planos Preventivos",
    "seed": {
      "dashboard": "Analisar a máquina ",
      "plans": "Listar os planos preventivos de "
    },
    "fallbackTitle": "Nova conversa · {{time}}",
    "groups": {
      "today": "Hoje",
      "yesterday": "Ontem",
      "thisWeek": "Esta semana",
      "thisMonth": "Este mês",
      "earlier": "Anterior"
    }
  },
  "dashboard": {
    "title": "Indicadores de manutenção",
    "subtitle": "MTBF, MTTR, disponibilidade e backlog calculados em tempo real.",
    "summary": "Resumo do tenant",
    "equipmentSeries": "Série temporal por equipamento",
    "equipmentTrend": "Tendência de MTBF (últimos 6 meses)",
    "topFailureModes": "Top 5 modos de falha",
    "equipmentSelector": "Selecionar equipamento",
    "periodSelector": "Selecionar período",
    "period": {
      "last30d": "Últimos 30 dias",
      "last90d": "Últimos 90 dias",
      "mtd": "Mês até hoje",
      "ytd": "Ano até hoje"
    },
    "kpi": {
      "mtbf": {
        "label": "MTBF",
        "description": "Tempo médio entre falhas, alvo industrial é > 100h."
      },
      "mttr": {
        "label": "MTTR",
        "description": "Tempo médio de reparo, alvo é < 4h em manutenção corretiva."
      },
      "availability": {
        "label": "Disponibilidade",
        "description": "Uptime sobre janela analisada. Alvo > 95%."
      },
      "backlog": {
        "label": "Backlog",
        "description": "OS abertas ainda não concluídas."
      }
    },
    "source": {
      "fallback": "WO fallback",
      "fallbackTooltip": "Calculado a partir de OS corretivas, Sprint C ainda não habilitou o modelo Incident."
    },
    "empty": {
      "series": "Sem ordens corretivas no período para gerar a série.",
      "noEquipment": "Cadastre um equipamento para visualizar a série temporal."
    },
    "error": {
      "scopeRequired": "Equipamento ou planta obrigatório.",
      "loadFailed": "Não foi possível carregar os dados. Tente novamente.",
      "retry": "Tentar novamente"
    },
    "card": {
      "openPlans": "Ver planos",
      "confidence": {
        "label": "Confiança",
        "high": "alta",
        "medium": "média",
        "low": "baixa"
      },
      "export": {
        "xlsx": "Exportar Excel",
        "docx": "Exportar Word (.docx)",
        "pdf": "Exportar PDF",
        "generating": "Gerando…",
        "error": "Falha ao gerar o arquivo. Tente novamente."
      },
      "plans": {
        "count_one": "{{count}} plano preventivo",
        "count_other": "{{count}} planos preventivos",
        "empty": "Nenhum plano preventivo encontrado.",
        "openTasks": "Ver tarefas",
        "searchPlaceholder": "Buscar plano ou equipamento",
        "viewSchedule": "Ver Cronograma",
        "noSearchResults": "Nenhum plano bate com a busca."
      },
      "seed": {
        "setPeriod": "Analisar a máquina {{tag}} no período {{period}}",
        "openPlans": "Listar os planos preventivos de {{tag}}",
        "planTasks": "Listar as tarefas do plano {{plan}}"
      },
      "teams": {
        "title": "Equipes",
        "count_one": "{{count}} equipe cadastrada",
        "count_other": "{{count}} equipes cadastradas",
        "empty": "Nenhuma equipe cadastrada ainda.",
        "col": {
          "name": "Equipe",
          "tag": "Código",
          "plant": "Planta",
          "specialty": "Especialidade",
          "technicians": "Técnicos"
        }
      },
      "materials": {
        "title": "Materiais",
        "count_one": "{{count}} material cadastrado",
        "count_other": "{{count}} materiais cadastrados",
        "empty": "Nenhum material cadastrado ainda.",
        "col": {
          "code": "Código",
          "description": "Descrição",
          "unit": "Unidade",
          "equipmentLinks": "Equipamentos"
        }
      },
      "notifications": {
        "title": "Notificações",
        "openCount_one": "{{count}} notificação aberta",
        "openCount_other": "{{count}} notificações abertas",
        "matchedCount_one": "{{count}} nesta busca",
        "matchedCount_other": "{{count}} nesta busca",
        "pageRange": "Mostrando {{from}} a {{to}}",
        "empty": "Nenhuma notificação encontrada.",
        "col": {
          "number": "Número",
          "equipment": "Equipamento",
          "type": "Tipo",
          "priority": "Prioridade",
          "status": "Status",
          "actions": "Ações",
          "detailing": "Detalhamento"
        },
        "status": {
          "open": "Aberta",
          "in_progress": "Em andamento",
          "closed": "Fechada"
        },
        "type": {
          "M1": "Nota de avaria",
          "M2": "Nota de mau funcionamento",
          "M3": "Nota de atividade"
        },
        "action": {
          "aria": "{{action}}: notificação {{number}}",
          "detail": "Detalhar",
          "complete": "Completar detalhamento",
          "open": "Abrir OS"
        },
        "detailing": {
          "sem_os": "Sem OS",
          "incompleta": "OS incompleta",
          "detalhada": "OS detalhada",
          "conflito": "Vínculo conflitante",
          "bloqueada": "Detalhamento indisponível",
          "unknown": "Detalhamento não informado"
        },
        "missing": {
          "operation_description": "Descrição da operação",
          "operation_team": "Equipe da operação",
          "operation_specialty": "Especialidade da operação",
          "planned_start": "Data planejada",
          "operation_duration": "Duração da operação",
          "operation_duration_unit": "Unidade de duração",
          "operation_system_condition": "Condição da instalação",
          "operations": "Operações",
          "unknown": "Informação necessária"
        }
      },
      "list": {
        "count_one": "{{count}} item",
        "count_other": "{{count}} itens",
        "countTruncated_one": "Mostrando {{shown}} de {{count}} item",
        "countTruncated_other": "Mostrando {{shown}} de {{count}} itens",
        "empty": "Nenhum item encontrado.",
        "detail": {
          "show": "Ver detalhes",
          "hide": "Ocultar detalhes"
        },
        "action": {
          "header": "Ação",
          "execute": "Executar"
        }
      }
    },
    "buildFooter": {
      "label": "AxiomGO · v{{version}} · build {{sha}}",
      "ariaLabel": "Informação de versão do sistema"
    }
  },
  "engine": {
    "online": "Motor Online",
    "offline": "Motor Offline",
    "reconnecting": "Reconectando..."
  },
  "errors": {
    "connectionLost": "Conexão perdida. Reconectando...",
    "timeout": "O servidor não respondeu a tempo. Por favor, tente novamente.",
    "generic": "Algo deu errado. Tente novamente ou entre em contato com o suporte.",
    "invalidFormat": "Formato inválido. Verifique os dados e tente novamente.",
    "sessionExpired": "Sua sessão expirou. Por favor, atualize a página.",
    "authError": "Sessão expirada. Faça login novamente.",
    "sessionRenewing": "Reautenticando sua sessão…",
    "sessionRenewed": "Sessão renovada. Se a última ação não andou, toque nela de novo.",
    "permissionDenied": "Sem permissão para acessar este recurso.",
    "rateLimited": "Muitas requisições. Aguarde alguns segundos.",
    "networkBlocked": "Não conseguimos falar com o servidor. Verifique sua conexão e tente novamente.",
    "streamFailed": "A resposta foi interrompida. Toque em \"Tentar novamente\" para reenviar.",
    "credentialTimeout": "Não consegui renovar sua credencial a tempo. Verifique a conexão e toque de novo.",
    "auth": {
      "invalidTenant": "Tenant inválido ou ausente. Contate o administrador da sua organização.",
      "providerUnavailable": "O provedor de autenticação está temporariamente indisponível. Tente novamente em instantes.",
      "notConfigured": "Autenticação não configurada. Contate o administrador do sistema.",
      "notApproved": "Apenas contas aprovadas podem acessar a plataforma."
    },
    "stream": {
      "llmUnavailable": "O modelo de IA está temporariamente indisponível. Tente novamente em alguns segundos.",
      "turnDeadlineExceeded": "A conversa não respondeu no tempo previsto e este turno foi encerrado. Mande de novo.",
      "requestUnconfirmed": "Ainda não foi possível confirmar o resultado do pedido anterior. Não iniciamos outra execução para evitar duplicação. Reabra a conversa para verificar a resposta antes de tentar novamente.",
      "internalError": "Algo deu errado no motor. Tente novamente ou entre em contato com o suporte."
    },
    "uniqueness": {
      "equipmentDuplicateTagInPlant": "O equipamento com tag \"{{tag}}\" já está cadastrado na planta \"{{plantName}}\". O registro existente será reutilizado.",
      "locationDuplicateCodeInPlant": "Já existe um local com código \"{{code}}\" na planta \"{{plantName}}\". Use outro código ou escolha uma planta diferente.",
      "teamDuplicateNameInPlant": "Já existe uma equipe com nome \"{{name}}\" na planta \"{{plantName}}\". Use outro nome ou escolha uma planta diferente.",
      "technicianDuplicatePersonnelNumberInTenant": "Já existe um técnico com matrícula \"{{personnelNumber}}\" neste tenant. Use outra matrícula."
    },
    "boundary": {
      "title": "Algo deu errado nesta parte da tela",
      "message": "O restante do AxiomGO continua funcionando. Recarregue para tentar de novo.",
      "retry": "Recarregar"
    },
    "loadRolesFailed": "Não foi possível carregar os perfis de acesso.",
    "loadTeamFailed": "Não foi possível carregar os membros da equipe."
  },
  "toasts": {
    "proposalApproved": "Proposta aprovada com sucesso",
    "proposalRejected": "Proposta rejeitada",
    "proposalAdjusted": "Proposta ajustada",
    "engineReconnected": "Motor reconectado",
    "newConversation": "Nova conversa iniciada",
    "themeChanged": "Tema alterado",
    "importComplete": "Importação concluída, {{count}} linhas",
    "importCompleteGeneric": "Importação concluída",
    "importError": "Falha na importação, toque para tentar novamente",
    "webSearchComplete": "Pesquisa concluída",
    "copyConversationSuccess": "Conversa copiada",
    "voicePermissionLost": "Permissão de microfone perdida. Use o teclado.",
    "rateLimited": "Você enviou muitas mensagens. Aguarde {{seconds}}s e tente de novo.",
    "turnInFlight": "Aguarde a resposta atual terminar. Sua mensagem continua no campo, pronta para enviar de novo.",
    "messageDropped": "Perdemos parte da resposta do sistema. Se a tela parecer travada, recarregue a página."
  },
  "proposal": {
    "approve": "Aprovar",
    "adjust": "Ajustar",
    "reject": "Rejeitar",
    "confidence": "Confiança"
  },
  "files": {
    "download": "Baixar",
    "attach": "Anexar arquivo",
    "camera": "Câmera",
    "capturePhoto": "Tirar foto",
    "photoAttachment": "Foto",
    "cameraNativePermissionDenied": "Acesso à câmera negado. Permita o acesso nas configurações do aplicativo e tente novamente.",
    "cameraUnavailable": "A câmera não está disponível neste dispositivo.",
    "cameraCaptureFailed": "Não foi possível capturar ou ler a foto. Tente novamente.",
    "cameraPermissionDenied": "Acesso à câmera foi negado. Permita o acesso à câmera nas configurações do navegador e tente novamente.",
    "unsupportedFormat": "\"{{filename}}\" não é um formato suportado.",
    "fileTooLarge": "\"{{filename}}\" é muito grande. Tamanho máximo é 50MB (20MB para imagens).",
    "tooManyFiles": "Máximo de 5 arquivos por mensagem.",
    "types": {
      "spreadsheet": "Planilha",
      "csv": "CSV",
      "pdf": "PDF",
      "document": "Documento",
      "image": "Imagem",
      "text": "Texto",
      "generic": "Arquivo"
    },
    "uploadFailed": "Falha ao enviar o arquivo. Tente novamente.",
    "attachmentContextChanged": "O contexto do anexo mudou. Selecione o arquivo novamente antes de enviar.",
    "uploadTenantMissing": "Sessão sem tenant. Faça login novamente.",
    "uploading": "Enviando arquivo...",
    "gallery": "Galeria",
    "uploadFailedStatus": "Falha ao enviar o arquivo (erro {{status}}). Tente novamente.",
    "uploadMissingFileId": "O servidor recebeu o arquivo mas não devolveu o identificador. Tente novamente.",
    "durableAttachmentsDisabled": "Não é possível enviar \"{{filename}}\" agora (arquivo grande desse tipo ainda não está liberado). Tente um arquivo menor ou aguarde a liberação."
  },
  "processing": {
    "default": "Processando..."
  },
  "form": {
    "submit": "Enviar",
    "submitted": "Dados enviados"
  },
  "validation": {
    "tagFormat": "Formato incorreto. Exemplo: BOM-2201A",
    "notaFormat": "Formato incorreto. Insira 8 a 10 dígitos.",
    "ordemFormat": "Formato incorreto. Insira 7 a 12 dígitos.",
    "currencyInvalid": "Valor monetário inválido.",
    "currencyNegative": "Valor não pode ser negativo.",
    "dateInvalid": "Data inválida. Verifique o formato."
  },
  "input": {
    "quickActions": "Ações rápidas",
    "suggestionsAvailable": "{{count}} sugestões disponíveis",
    "chatAriaLabel": "Campo de mensagem do chat"
  },
  "conversation": {
    "delete": {
      "confirm": "Excluir esta conversa? Esta ação não pode ser desfeita.",
      "button": "Excluir"
    },
    "empty": {
      "title": "Sua planta, orquestrada.",
      "subtitle": "Do cadastro ao plano preventivo, da falha à ordem de serviço concluída: o AxiomGO conduz cada etapa com você.",
      "cta": "Nova conversa"
    },
    "untitled": "Conversa sem título",
    "edit": {
      "placeholder": "Nome da conversa",
      "title": "Editar o nome da conversa"
    },
    "rename": "Renomear",
    "menu": "Mais opções"
  },
  "import": {
    "analyzeFailed": "Falha ao analisar a planilha. Tente novamente.",
    "executeFailed": "Falha ao executar a importação. Nada foi importado. Verifique sua conexão e tente novamente.",
    "proposal": {
      "title": "Importação: {{fileName}}",
      "rows": "{{count}} linhas",
      "columns": "{{count}} colunas",
      "entity": "Entidade detectada: {{entity}}",
      "unmapped": "{{count}} colunas não mapeadas",
      "issues": "{{count}} problemas detectados",
      "confirm": "Importar com este mapeamento",
      "confirmWithId": "Confirmo a importação da proposta {{proposalId}} com os mapeamentos exibidos.",
      "adjust": "Ajustar mapeamento",
      "cancel": "Cancelar",
      "adjustPlaceholder": "Descreva os ajustes desejados (ex: \"XPTO é o número de patrimônio\")",
      "table": {
        "source": "Sua Coluna",
        "target": "Campo AxiomGO",
        "confidence": "Conf.",
        "sample": "Amostra"
      },
      "processing": "Processando..."
    },
    "progress": {
      "title": "Importando {{entity}}...",
      "enqueued": "Importação de {{entity}} na fila",
      "completed": "Importação de {{entity}} concluída",
      "completedWithErrors": "Importação de {{entity}} concluída com falhas",
      "failed": "Importação de {{entity}} falhou",
      "records": "{{processed}} / {{total}} registros",
      "imported": "{{count}} importados",
      "skipped": "{{count}} ignorados",
      "errors": "{{count}} erros",
      "eta": "Tempo estimado: ~{{time}}"
    },
    "report": {
      "success": "Importação concluída!",
      "failure": "Importação falhou",
      "imported": "{{count}} {{entity}} importados",
      "autocreated": "{{count}} dependências criadas",
      "skipped": "{{count}} duplicatas ignoradas",
      "errors": "{{count}} linhas com erro",
      "duration": "Duração: {{time}}",
      "download": "Baixar relatório de erros"
    },
    "validation": {
      "title": "Validação completa",
      "valid": "{{count}} linhas válidas",
      "errors": "{{count}} linhas com erro",
      "warnings": "{{count}} avisos",
      "missingTitle": "Dependências faltantes:",
      "missing": "{{count}} {{entity}} não encontrados",
      "duplicates": "{{count}} registros já existem",
      "importAnyway": "Importar mesmo assim",
      "createAndImport": "Criar dependências e importar",
      "processing": "Processando..."
    },
    "entity": {
      "Equipment": "Equipamentos",
      "Location": "Locais",
      "Plant": "Plantas",
      "Material": "Materiais",
      "MaintPlan": "Planos de Manutenção",
      "WorkOrder": "Ordens de Serviço",
      "Team": "Equipes",
      "Technician": "Técnicos",
      "Notification": "Notificações",
      "Supplier": "Fornecedores",
      "Specialty": "Especialidades"
    },
    "templateOffer": {
      "title": "Não tem template ainda?",
      "subtitle": "Baixe um modelo Excel pronto para preencher e enviar.",
      "levelLabel": "Modelo:",
      "levelBasic": "Básico (campos obrigatórios)",
      "levelFull": "Completo (todos os campos)",
      "langLabel": "Idioma:",
      "downloadAll": "Baixar todos (.zip)",
      "downloadingAll": "Gerando pacote...",
      "error": "Falha ao baixar template: {{msg}}"
    },
    "dropzone": {
      "text": "Solte o arquivo para importar",
      "unsupported": "Formato não suportado. Use .xlsx, .xls ou .csv",
      "uploading": "Enviando...",
      "analyzing": "Analisando...",
      "sent": "Enviado"
    },
    "file": {
      "size": {
        "kb": "{{size}} KB",
        "mb": "{{size}} MB"
      },
      "rows": "{{count}} linhas",
      "sheets": "{{count}} abas"
    },
    "detection": {
      "detected": "Planilha identificada como {{entity}} ({{confidence}}% de confiança)",
      "lowConfidence": "Não consegui identificar o tipo de dados com certeza. Parece ser {{entity}}, confirma?",
      "unknown": "Não reconheci o tipo de dados. Pode me dizer o que esta planilha contém?",
      "learned": "Reconheci este formato de importações anteriores",
      "profileAutoApplied": "Perfil aprendido aplicado automaticamente"
    },
    "defaults": {
      "applied": "{{field}} definido como {{value}} ({{standard}})",
      "criticality_b": "Criticidade B aplicada, padrão ISO 55001 para ativos sem classificação"
    },
    "dependencies": {
      "willCreate": "{{entity}} '{{name}}' será criado automaticamente",
      "created": "{{entity}} '{{name}}' criado com sucesso",
      "failed": "Não foi possível criar {{entity}} '{{name}}': {{reason}}"
    },
    "template": {
      "askEntity": "Para qual tipo de dado você precisa do template?",
      "generating": "Gerando template de {{entity}}...",
      "ready": "Template de {{entity}} pronto!",
      "downloadHint": "Baixe, preencha e envie de volta para importar.",
      "requiredColumns": "Colunas obrigatórias: {{columns}}",
      "exampleIncluded": "Incluí um exemplo real do seu banco de dados."
    },
    "webSearch": {
      "consultedWeb": "Pesquisa web realizada",
      "dataFrom": "Com base no manual do fabricante",
      "maintenancePlan": "Plano de Manutenção Preventiva",
      "manufacturer": "Fabricante",
      "model": "Modelo",
      "equipmentType": "Tipo",
      "viewSources": "Ver fontes ({{count}})",
      "hideSources": "Ocultar fontes",
      "importOffer": "Deseja importar o plano preventivo?",
      "importTasks_zero": "{{count}} tarefas",
      "importTasks_one": "{{count}} tarefa",
      "importTasks_other": "{{count}} tarefas",
      "importYes": "Sim, importar",
      "importInfo": "Só quero a info",
      "importStarted": "Importação iniciada",
      "infoOnly": "Ok, mantendo apenas a informação",
      "confidence": "confiança",
      "cached": "dados em cache",
      "cachedAgo": "de {{time}} atrás"
    },
    "webSearchCard": {
      "plan": {
        "period": {
          "horas": "HORAS",
          "diario": "DIÁRIO",
          "semanal": "SEMANAL",
          "mensal": "MENSAL",
          "anual": "ANUAL",
          "ciclos": "CICLOS",
          "naoEspecificado": "NÃO ESPECIFICADO"
        },
        "totals": "TOTAIS DO PLANO",
        "importQuestion": "Deseja importar o plano preventivo?",
        "importYes": "Sim, importar",
        "importInfoOnly": "Só quero a info",
        "seeDetails": "ver detalhes",
        "hideDetails": "ocultar detalhes",
        "technicianNotSpecified": "Não especificado"
      }
    },
    "multiSheet": {
      "analysisTitle": "Analisei sua planilha \"{{fileName}}\"",
      "sheetsFound": "{{count}} aba(s) encontrada(s)",
      "rowCount": "{{count}} registros",
      "unrecognizedSheet": "Aba não reconhecida, será ignorada",
      "unmapped": "Sem correspondência",
      "colExcel": "Coluna",
      "colCmms": "Campo AxiomGO",
      "colConfidence": "Conf.",
      "colSheet": "Aba",
      "colEntity": "Entidade",
      "approveAll": "Importar tudo",
      "reviewDependencies": "Revisar dependências",
      "cancel": "Cancelar",
      "dependenciesTitle": "Dependências não cadastradas",
      "dependenciesCount": "{{count}} item(ns) precisam ser criados",
      "selectAll": "Selecionar todos",
      "createAndImport": "Criar selecionados e importar",
      "skipAndImport": "Pular e importar sem criar",
      "noAutoCreate": "Não pode ser criado automaticamente",
      "registerPlantFirst": "Cadastre a planta antes",
      "registerViaChatFirst": "Cadastre pelo chat antes de importar",
      "readyToImport": "Pronto para importar",
      "recordsSummary": "{{records}} registros em {{sheets}} abas",
      "depsToCreate": "+ {{count}} itens a criar",
      "importOrder": "Ordem de importação",
      "executeImport": "Executar importação",
      "back": "Voltar",
      "importing": "Importando {{entity}}...",
      "importingSheet": "Aba \"{{sheet}}\" ({{current}}/{{total}})",
      "completed": "Importação concluída",
      "partial": "Importação parcial",
      "failed": "Importação falhou",
      "duration": "Concluído em {{seconds}}s",
      "created": "Criados",
      "updated": "Atualizados",
      "skipped": "Ignorados",
      "errors": "Erros",
      "rowError": "Linha {{row}}: {{message}}",
      "reasonMissing": "A importação falhou e o motivo não veio na resposta. Baixe o relatório de erros ou envie a planilha novamente.",
      "nothingExecutable": "Nenhuma aba está liberada para importar. As abas reconhecidas com confiança parcial precisam da sua confirmação antes de gravar qualquer linha."
    },
    "job": {
      "title": "Importação em andamento",
      "titleCompleted": "Importação concluída",
      "titleCompletedWithErrors": "Importação concluída com falhas",
      "correctionsApplied": "Correções aplicadas",
      "correctionsPartial": "Correções parcialmente aplicadas",
      "initialProcessing": "Processamento inicial:",
      "titleFailed": "Importação falhou",
      "titleCanceled": "Importação cancelada",
      "titleStalled": "Importação sem resposta",
      "state": {
        "pending": "Aguardando início",
        "enqueued": "Em fila",
        "running": "Importando...",
        "completed": "Concluído",
        "completed_with_errors": "Concluído com falhas",
        "failed": "Falhou",
        "canceled": "Cancelado",
        "stalled": "Sem resposta"
      },
      "stalled": {
        "title": "Importação sem resposta",
        "body": "Não recebemos atualização do servidor. A importação pode ainda estar rodando ou ter sido interrompida.",
        "checkNow": "Verificar agora",
        "dismiss": "Dispensar"
      },
      "imported": "Importadas",
      "skipped": "Ignoradas",
      "errors": "Erros",
      "failedRows": "Linhas com falha",
      "currentSheet": "Aba atual",
      "duration": "Duração: {{seconds}} s",
      "viewFailedRows": "Ver linhas com falha",
      "viewSkippedRows": "Ver linhas ignoradas",
      "errorMessage": "Mensagem de erro: {{message}}",
      "skippedSheets_one": "{{count}} aba não reconhecida: {{names}}",
      "skippedSheets_other": "{{count}} abas não reconhecidas: {{names}}",
      "fixedActions": {
        "openCorrectiveOrder": "Abrir OS Corretiva",
        "generateMaintenancePlan": "Gerar plano de manutenção",
        "viewMyEquipment": "Ver meus equipamentos"
      }
    },
    "pendingSheet": {
      "title": "Abas aguardando sua confirmação:",
      "row": "{{sheet}}: parece {{entity}} ({{rows}} linhas)",
      "accept": "Importar como {{entity}}",
      "ignore": "Ignorar esta aba",
      "accepted": "Aba confirmada. A importação foi enfileirada.",
      "ignored": "Aba ignorada. Nada foi importado dela.",
      "failed": "Não foi possível registrar a decisão. Tente novamente."
    },
    "failedRows": {
      "title": "Linhas com falha ({{count}})",
      "colRow": "Linha",
      "colSheet": "Aba",
      "colField": "Campo",
      "colReason": "Motivo",
      "loading": "Carregando...",
      "empty": "Nenhum detalhe disponível para este job.",
      "loadError": "Não foi possível carregar as linhas com falha. Tente novamente.",
      "retry": "Tentar de novo",
      "prev": "← Anterior",
      "next": "Próxima →",
      "download": "Baixar relatório de erros",
      "close": "Fechar",
      "colCorrecao": "Correção",
      "escolha": "Escolha...",
      "semTipoConhecido": "Corrija na planilha e importe de novo",
      "corrigirCampo": "Corrigir {{campo}}",
      "cadastreDependencia": "Cadastre {{entidade}} antes de reenviar esta linha",
      "reenviar": "Reimportar {{count}} linha(s) corrigida(s)",
      "reenviando": "Reimportando...",
      "linhaCorrigida": "Corrigida",
      "linhaFalhou": "Ainda com falha",
      "contagem": "{{total}} falhas → {{corrigidas}} corrigidas → {{pendentes}} pendentes",
      "erroVazio": "Preencha este campo",
      "erroNumero": "Use um número",
      "erroData": "Data não existe",
      "erroOpcao": "Escolha um dos valores da lista",
      "erroBooleano": "Use sim ou não",
      "erroSemTipo": "Este campo não pode ser corrigido aqui",
      "erroAoReenviar": "Não consegui reimportar as linhas. Tente de novo.",
      "valorQueVeio": "Veio: {{valor}}"
    },
    "skippedRows": {
      "title": "Linhas ignoradas ({{count}})",
      "colRow": "Linha",
      "colSheet": "Aba",
      "colReason": "Motivo",
      "loading": "Carregando...",
      "empty": "Nenhuma linha foi ignorada nesta importação.",
      "loadError": "Não foi possível carregar as linhas ignoradas. Tente novamente.",
      "retry": "Tentar de novo",
      "prev": "← Anterior",
      "next": "Próxima →",
      "close": "Fechar",
      "reason": {
        "duplicate": "Linha duplicada",
        "no_match": "Linha sem correspondência com nenhum cadastro",
        "other": "Motivo não classificado pelo sistema"
      },
      "reasonFallback": "Linha não reconhecida. Confira os dados desta linha."
    },
    "inlineForm": {
      "code": "Código",
      "codeExemplo": "PL-02",
      "name": "Nome",
      "nameExemplo": "Planta Piracicaba",
      "country": "País (2 letras)",
      "countryExemplo": "BR",
      "timezone": "Fuso horário",
      "timezoneExemplo": "America/Sao_Paulo",
      "erroObrigatorio": "Preencha este campo",
      "erroPais": "Use a sigla de 2 letras do país, como BR",
      "erroFuso": "Fuso horário não existe. Use o formato America/Sao_Paulo",
      "erroAoCriar": "Não consegui criar o cadastro. Tente de novo.",
      "criando": "Criando cadastro..."
    }
  },
  "search": {
    "webIndicator": "Consultei a web · sugestão com base no manual {{manufacturer}}",
    "webIndicatorCached": "(dados em cache de {{hours}}h atras)",
    "viewDetails": "Ver detalhes completos",
    "hideDetails": "Ocultar detalhes",
    "viewSources": "Ver fontes ({{count}})",
    "hideSources": "Ocultar fontes",
    "sourcesTitle": "Fontes consultadas",
    "importOffer": "Deseja cadastrar esta sugestão de plano preventivo para o {{tag}}?",
    "importTaskCount": "Serão criadas {{count}} tarefas com os intervalos sugeridos. Revise antes de aplicar.",
    "importYes": "Sim, importar",
    "importNo": "Não, só quero a info",
    "importSuccess_zero": "Sugestão revisada e cadastrada: plano preventivo com {{count}} tarefas. Próxima {{task}}: {{date}}.",
    "importSuccess_one": "Sugestão revisada e cadastrada: plano preventivo com {{count}} tarefa. Próxima {{task}}: {{date}}.",
    "importSuccess_other": "Sugestão revisada e cadastrada: plano preventivo com {{count}} tarefas. Próxima {{task}}: {{date}}.",
    "importSuccessNoNext_zero": "Sugestão revisada e cadastrada: plano preventivo com {{count}} tarefas.",
    "importSuccessNoNext_one": "Sugestão revisada e cadastrada: plano preventivo com {{count}} tarefa.",
    "importSuccessNoNext_other": "Sugestão revisada e cadastrada: plano preventivo com {{count}} tarefas.",
    "importPending": "Importando o plano preventivo. Aguardando a confirmação do motor.",
    "importStillProcessing": "A importação continua processando. A confirmação aparece aqui na conversa assim que terminar.",
    "importFailedTitle": "Não consegui importar o plano preventivo.",
    "importError": "Volte à conversa e peça para eu importar o plano novamente.",
    "confidenceHigh": "confianca alta",
    "confidenceMedium": "confianca media",
    "confidenceLow": "confianca baixa",
    "noResults": "Não encontrei dados do fabricante {{manufacturer}} na web."
  },
  "webSearch": {
    "consultedWeb": "Consultei a web",
    "dataFrom": "sugestão com base no manual do fabricante",
    "headerLabel": "Consultei a web · sugestão com base no manual do fabricante",
    "headerLabelLibrary": "Veio da Biblioteca · {{when}}",
    "headerLabelManual": "Li o manual anexado · sugestão com base no manual",
    "headerLabelNeutral": "Busca web",
    "maintenancePlan": "Plano de Manutenção Preventiva",
    "preventivePlanLabel": "Plano preventivo",
    "planTotals": "Totais do plano",
    "manufacturer": "Fabricante",
    "model": "Modelo",
    "equipmentType": "Tipo",
    "viewSources": "Ver fontes ({{count}})",
    "hideSources": "Ocultar fontes",
    "importOffer": "Deseja importar o plano preventivo?",
    "importTasks_zero": "{{count}} tarefas",
    "importTasks_one": "{{count}} tarefa",
    "importTasks_other": "{{count}} tarefas",
    "importYes": "Sim, importar",
    "importInfo": "Só quero a info",
    "importStarted": "Importação iniciada",
    "infoOnly": "Ok, mantendo apenas a informação",
    "confidence": {
      "badgeLabel": "{{pct}}%",
      "noData": "sem dados",
      "tooltip": "Confiança {{pct}}%, {{chunks}} chunks de {{urls}} URLs",
      "noDataTooltip": "Dados de confiança não disponíveis"
    },
    "cached": "dados em cache",
    "cachedAgo": "de {{time}} atras",
    "taskCount_zero": "{{count}} tarefas",
    "taskCount_one": "{{count}} tarefa",
    "taskCount_other": "{{count}} tarefas",
    "durationEstimated": "(est.)",
    "materialsLabel": "Materiais",
    "toolsLabel": "Ferramentas",
    "lubricantLabel": "Lubrificante",
    "workTypeLabel": "Disciplina",
    "peopleRequiredLabel": "Equipe",
    "peopleRequiredValue_one": "{{count}} pessoa",
    "peopleRequiredValue_other": "{{count}} pessoas",
    "noPlanFound": "Não encontrei plano específico para {{manufacturer}} {{model}}. Você pode:",
    "openManual": "Buscar manual no fabricante",
    "registerManually": "Cadastrar este equipamento",
    "usualPlanDisclaimer": "Não encontramos o manual do equipamento, porém inferimos um plano seguindo as práticas de mercado.",
    "headerInferred": "Consultei a web · sugestão com base em equipamento similar",
    "headerMarketPractice": "Consultei a web · sugestão com base em práticas da classe e normas",
    "inferredDisclaimer": "Não encontramos o manual do {{manufacturer}} {{model}}, porém inferimos um plano seguindo as práticas de mercado.",
    "registerEquipmentCta": "Cadastrar este equipamento",
    "montarPlanoPreventivo": "Montar o Plano Preventivo",
    "refineSearch": "Refinar busca",
    "unavailable": {
      "title": "Pesquisa de plano",
      "body": "O serviço de pesquisa de planos está indisponível no momento."
    },
    "noSources": {
      "title": "Nenhuma fonte encontrada",
      "body": "Não encontrei fontes na web para {{manufacturer}} {{model}}. Você pode cadastrar o equipamento manualmente.",
      "retry": "Tentar novamente",
      "registerManually": "Cadastrar este equipamento"
    },
    "workType": {
      "electrical": "Eletrica",
      "mechanical": "Mecanica",
      "instrumentation": "Instrumentacao",
      "hydraulic": "Hidraulica",
      "pneumatic": "Pneumatica",
      "lubrication": "Lubrificacao",
      "civil": "Civil",
      "inspection": "Inspecao",
      "other": "Outro"
    },
    "lowConfidenceTitle": "Baixa confianca",
    "lowConfidenceHint": "Confirme com o manual do fabricante antes de aplicar.",
    "notRegisteredTitle": "Equipamento não cadastrado",
    "notRegisteredBody": "Não encontrei {{manufacturer}} {{model}} no seu cadastro. Posso criar o equipamento e já importar as {{count}} tarefas do plano preventivo?",
    "confirmCreateAndImport": "Criar e importar",
    "creatingAndImporting": "Criando equipamento e importando plano...",
    "createCancelled": "Ok, mantendo apenas a informação do fabricante.",
    "plan": {
      "presentation": {
        "pendingField": "Tradução pendente",
        "unavailableField": "Tradução indisponível",
        "pending": "Preparando tradução do plano…",
        "unavailable": "Tradução do plano indisponível. O plano ainda não está totalmente traduzido.",
        "retry": "Tentar traduzir novamente",
        "original": "Mostrar fonte original (idioma de origem)"
      },
      "headers": {
        "task": "Tarefa",
        "criticality": "Crit.",
        "period": "Período",
        "technician": "Técnico",
        "materials": "Materiais",
        "tools": "Ferramentas",
        "time": "Tempo",
        "citations": "Fontes",
        "timeDecimal": "Horas decimais",
        "procedure": "Procedimento"
      },
      "export": {
        "title": "AxiomGO: Plano de manutenção",
        "sheetName": "Plano de manutenção",
        "equipmentLabel": "Equipamento",
        "typeLabel": "Tipo",
        "noticeLabel": "Aviso",
        "inferredDisclaimer": "Plano usual (estimativa), NÃO é do fabricante. Gerado a partir de equipamentos similares. Valide antes de executar.",
        "proceduresTitle": "Procedimentos"
      },
      "criticality": {
        "A": "Crítico A",
        "B": "Grau B",
        "C": "Grau C",
        "inferred": "Inferido pela IA"
      },
      "unit": {
        "DAYS_one": "{{count}} dia",
        "DAYS_other": "{{count}} dias",
        "WEEKS_one": "{{count}} semana",
        "WEEKS_other": "{{count}} semanas",
        "MONTHS_one": "{{count}} mês",
        "MONTHS_other": "{{count}} meses",
        "YEARS_one": "{{count}} ano",
        "YEARS_other": "{{count}} anos",
        "CYCLES_one": "{{count}} ciclo",
        "CYCLES_other": "{{count}} ciclos"
      },
      "skill": {
        "mechanical": "Mecânico",
        "electrical": "Eletricista",
        "instrumentation": "Instrumentista",
        "lubrication": "Lubrificação",
        "inspection": "Inspeção",
        "general": "Geral",
        "operator": "Operador"
      },
      "cert": {
        "NR-10": "NR-10",
        "NR-13": "NR-13"
      },
      "toolType": {
        "mechanical": "Mecânica",
        "electrical": "Elétrica",
        "measurement": "Medição",
        "safety": "EPI/Segurança",
        "lifting": "Içamento",
        "other": "Outro"
      },
      "oemLabel": "OEM",
      "nonOemLabel": "NÃO-OEM",
      "band": {
        "por_turno": "Por turno",
        "diaria": "Diária",
        "semanal": "Semanal",
        "mensal": "Mensal",
        "trimestral": "Trimestral",
        "semestral": "Semestral",
        "anual": "Anual",
        "por_hora_operacao": "Por hora de operação",
        "por_condicao": "Por condição"
      },
      "noCadence": "Sem cadência declarada",
      "triggers": {
        "pair": "{{a}} ou {{b}}",
        "anyFirst": "o que vier primeiro",
        "firstService": "1ª troca: {{x}}"
      },
      "expandSteps": "Expandir passos",
      "importButton": "Importar plano de manutenção",
      "exportLabel": "Exportar",
      "exportXlsx": "Excel (.xlsx)",
      "exportDocx": "Word (.docx)",
      "exportPreparing": "Preparando arquivo…",
      "exportTimeout": "O preparo do arquivo excedeu o tempo limite. Nenhum arquivo foi gerado. Clique em Excel ou Word para tentar novamente.",
      "exportError": "Não foi possível gerar o arquivo. Tente novamente.",
      "exportTranslationUnavailable": "Não foi possível traduzir todo o plano para o idioma selecionado. Nenhum arquivo foi gerado. Tente novamente quando a tradução estiver disponível.",
      "import": {
        "disabled": "Plano não atende critérios mínimos. Refine a busca ou cadastre manualmente."
      },
      "confidence": {
        "overall": "Confiança geral",
        "by_dimension": {
          "period": "Período",
          "technician": "Técnico",
          "materials": "Materiais",
          "tools": "Ferramentas",
          "duration": "Tempo"
        }
      },
      "citation": {
        "title": "Fontes desta tarefa"
      },
      "equipmentTypeName": {
        "air_compressor": "Compressor de ar",
        "boiler": "Caldeira",
        "centrifugal_pump": "Bomba centrífuga",
        "conveyor_belt": "Correia transportadora",
        "cooling_tower": "Torre de resfriamento",
        "diesel_generator": "Gerador a diesel",
        "electric_motor": "Motor elétrico",
        "forklift": "Empilhadeira",
        "heat_exchanger": "Trocador de calor",
        "hydraulic_press": "Prensa hidráulica",
        "industrial_fan": "Ventilador industrial",
        "overhead_crane": "Ponte rolante",
        "reciprocating_compressor": "Compressor alternativo",
        "rotary_screw_compressor": "Compressor rotativo de parafuso",
        "screw_compressor": "Compressor de parafuso",
        "vacuum_pump": "Bomba de vácuo"
      },
      "procedureOrigin": "Procedimento por {{origin}}, não do fabricante",
      "aiFooter": "Sugestão gerada por IA a partir das fontes citadas. Revise antes de aplicar: a decisão final é do responsável técnico.",
      "provenanceTier": {
        "pratica_setor": "prática do setor",
        "analogia": "analogia",
        "inferencia": "inferência",
        "norma": "norma técnica"
      },
      "tasksOmitted_one": "{{count}} tarefa do plano não está nesta tabela: o plano excedeu o teto do motor.",
      "tasksOmitted_other": "{{count}} tarefas do plano não estão nesta tabela: o plano excedeu o teto do motor."
    },
    "rawFindingsHeading": "Achados do manual",
    "rawFindingsHint": "Evidências textuais extraídas das fontes (não estruturadas)",
    "v2": {
      "empty": "Não foi possível estruturar um plano de manutenção a partir das fontes disponíveis.",
      "degraded": "Não foi possível estruturar um plano completo. Achados manuais extraídos das fontes:",
      "findingsTitle": "Achados de manutenção brutos"
    },
    "cache": {
      "hitChip": "resultado de {{ago}} atrás",
      "refresh": "Atualizar",
      "refreshAria": "Atualizar resultado, buscar dados novos ignorando o cache"
    },
    "debug": {
      "pipelineCounters": "Telemetria do funil (admin)",
      "counterKey": "Etapa",
      "counterValue": "Contagem"
    }
  },
  "preventivePlan": {
    "title": "Plano Preventivo, rascunho",
    "empty": "Nenhuma tarefa. Adicione ao menos uma para salvar o rascunho.",
    "headers": {
      "task": "Tarefa",
      "frequency": "Frequência",
      "specialty": "Especialidade",
      "cycleStart": "Início de ciclo",
      "actions": "Ações"
    },
    "unit": {
      "hours": "horas",
      "days": "dias",
      "weeks": "semanas",
      "months": "meses"
    },
    "specialty": {
      "mechanical": "Mecânica",
      "electrical": "Elétrica",
      "instrumentation": "Instrumentação",
      "lubrication": "Lubrificação",
      "inspection": "Inspeção",
      "general": "Geral"
    },
    "daysHint": "≈ {{days}}d",
    "addRow": "+ Adicionar tarefa",
    "saveDraft": "Salvar Rascunho",
    "deleteRow": "Excluir linha",
    "placeholderWarning": "Cadência estimada: revise antes de salvar.",
    "entryCard": {
      "title": "Como você quer criar o plano preventivo?",
      "whichEquipment": "Para qual equipamento é o plano?",
      "registerEquipment": "Cadastrar equipamento",
      "import": "Importar",
      "webSearch": "Buscar na Web",
      "manual": "Cadastrar Manualmente"
    },
    "manualStartHint": "Adicione cada tarefa: o que fazer, de quantos em quantos dias, qual especialidade e quais materiais. Comece pela primeira.",
    "addRowHint": "Dica: nomeie pelo verbo, 'Trocar', 'Inspecionar', 'Lubrificar'.",
    "confirmText": "Plano(s) salvos como rascunho (inativos). Ative quando quiser que entrem na programação.",
    "guidance": {
      "noTeam": "Nenhuma equipe cadastrada. Deseja criar uma equipe padrão?",
      "createDefaultTeam": "Criar equipe padrão",
      "missingMaterial": "Alguns materiais não existem no estoque. Deseja cadastrá-los agora?",
      "registerMaterials": "Cadastrar materiais"
    },
    "suggestion": {
      "title": "Sugestão: montar plano preventivo",
      "withoutPlanSuffix": "equipamentos sem plano preventivo",
      "startA": "Começar pelos A (críticos)",
      "startB": "Começar pelos B",
      "startC": "Começar pelos C",
      "manual": "Montar manual",
      "dismiss": "Não me lembre por 7 dias",
      "close": "Fechar lembrete",
      "headline_one": "1 equipamento crítico ({{criticality}}) sem plano preventivo",
      "headline_other": "{{count}} equipamentos críticos ({{criticality}}) sem plano preventivo"
    },
    "suggestionBell": {
      "aria": "Sugestões de plano preventivo",
      "withoutActivePlan_one": "equipamento sem plano preventivo",
      "withoutActivePlan_other": "equipamentos sem plano preventivo",
      "draftsAwaitingApproval_one": "rascunho aguardando aprovação",
      "draftsAwaitingApproval_other": "rascunhos aguardando aprovação"
    }
  },
  "execution": {
    "confirmed": "Confirmado no sistema",
    "partial": "Parcialmente registrado",
    "failure": "Não registrado no sistema",
    "mismatch": "O que foi registrado diverge do que foi pedido. Confira os itens abaixo.",
    "summary": "{{created}} criados · {{failed}} falhas",
    "status": {
      "created": "Criado",
      "failed": "Falhou"
    },
    "entity": {
      "work_order": "Ordens de serviço",
      "equipment": "Equipamentos",
      "location": "Localizações",
      "maintenance_plan": "Planos de manutenção",
      "part": "Peças",
      "goods_receipt": "Recebimentos",
      "notification": "Notificações"
    }
  },
  "teamTechnicianBatchReceipt": {
    "title": "Técnicos cadastrados",
    "badge": {
      "saved": "SALVO",
      "partial": "{{saved}} DE {{total}} SALVOS"
    },
    "status": {
      "saved": "salvo"
    },
    "summary": "{{technicians}} técnicos · {{teams}} times criados"
  },
  "entityCard": {
    "entity": {
      "WorkOrder": "Ordem de serviço",
      "Notification": "Notificação",
      "WoOperation": "Operação",
      "WoComponent": "Componente",
      "MaterialDocument": "Documento de material",
      "Proposal": "Proposta",
      "Equipment": "Equipamento",
      "Location": "Localização",
      "Plant": "Planta",
      "Material": "Material",
      "Team": "Equipe",
      "Technician": "Técnico",
      "MaintPlan": "Plano de manutenção",
      "MaintTaskList": "Lista de tarefas",
      "MaintTaskListOperation": "Operação da lista",
      "MaintTaskListComponent": "Componente da lista",
      "MaintenanceItem": "Item de manutenção",
      "MaintenanceCycle": "Ciclo de manutenção",
      "LtpScenario": "Cenário",
      "rotary_screw_compressor": "Compressor de parafuso rotativo",
      "unknown": "Equipamento"
    },
    "field": {
      "businessId": "Identificador",
      "description": "Descrição técnica",
      "status": "Status",
      "origin": "Origem",
      "balanceAfter": "Saldo",
      "count": "Quantidade",
      "operationNumber": "Operação",
      "equipmentTag": "Equipamento",
      "equipmentName": "Nome do equipamento",
      "plantName": "Planta",
      "taskCount": "Tarefas",
      "plannedWoCount": "OS planejadas",
      "period": "Período"
    },
    "unit": {
      "days": "dias",
      "hours": "horas",
      "cycles": "ciclos"
    },
    "status": {
      "draft": "Rascunho",
      "open": "Aberta",
      "active": "Ativo",
      "in_progress": "Em andamento",
      "paused": "Pausada",
      "completed": "Concluída",
      "closed": "Fechada",
      "cancelled": "Cancelada",
      "canceled": "Cancelada",
      "deleted": "Excluído",
      "pending": "Pendente",
      "approved": "Aprovada",
      "partial": "Parcial",
      "rejected": "Rejeitada",
      "auto_approved": "Aprovada automaticamente",
      "technically_complete": "Tecnicamente concluída"
    },
    "export": {
      "xlsx": "Exportar Excel",
      "pdf": "Exportar PDF (.docx)",
      "generating": "Gerando arquivo…",
      "error": "Falha ao exportar."
    }
  },
  "actions": {
    "approve": "Aprovar",
    "adjust": "Ajustar",
    "dismiss": "Dispensar",
    "yes": "Sim",
    "no": "Não"
  },
  "auth": {
    "signIn": "Entrar",
    "signUp": "Criar conta",
    "signOut": "Sair",
    "statusUnavailable": "Verificação de acesso temporariamente indisponível. Tentando novamente.",
    "pendingApproval": {
      "title": "Aguardando aprovação",
      "message": "Seu cadastro está aguardando aprovação de um administrador. Você será redirecionado automaticamente quando aprovado."
    }
  },
  "connection": {
    "signIn": "Entrar",
    "status": {
      "disconnected": "Desconectado",
      "connecting": "Conectando...",
      "connected": "Engine Online",
      "reconnecting": "Reconectando... ({{count}}/{{max}})",
      "degraded": "Modo alternativo (REST)",
      "offline": "Offline, mensagens na fila"
    },
    "banner": {
      "degraded": "Conexão instável. Usando modo alternativo (REST).",
      "offline": "Sem conexão. Mensagens serão enviadas quando reconectar.",
      "reconnecting": "Reconectando ao Engine..."
    }
  },
  "team": {
    "previousDeliveryPending": "A revogação do e-mail anterior ainda não foi confirmada. Use apenas este novo link.",
    "invitationSent": "Convite enviado para {{email}}. O link também está disponível abaixo.",
    "pending": {
      "copy": "Copiar link",
      "copied": "Link copiado."
    },
    "invitationLink": "Link de aceite",
    "shareInvitation": "Convite criado. Nenhum e-mail foi enviado. Compartilhe este link somente com {{email}}.",
    "invitationExpires": "Válido até {{date}}.",
    "title": "Equipe",
    "subtitle": "Gerencie membros e papéis do tenant",
    "member": "Membro",
    "role": "Papel",
    "status": "Status",
    "statusActive": "Ativo",
    "statusSuspended": "Suspenso",
    "invite": "Convidar",
    "inviteTitle": "Convidar novo membro",
    "email": "E-mail",
    "selectRole": "Selecione um papel",
    "sendInvite": "Gerar convite",
    "inviteSuccess": "Convite gerado com sucesso",
    "inviteFailed": "Falha ao gerar convite",
    "changeRole": "Alterar papel",
    "revoke": "Remover",
    "confirmRevoke": "Remover {{name}} do tenant?",
    "revokeSuccess": "Membro removido",
    "revokeFailed": "Falha ao remover",
    "roleChangedSuccess": "Papel atualizado",
    "roleChangeFailed": "Falha ao atualizar papel",
    "changeRoleTitle": "Alterar papel de {{name}}",
    "newRole": "Novo papel",
    "saveRole": "Salvar",
    "empty": "Nenhum membro nesse tenant ainda",
    "roles": {
      "owner": "Proprietário",
      "admin": "Administrador",
      "engineer": "Engenheiro",
      "viewer": "Visualizador",
      "field_technician": "Técnico de campo"
    }
  },
  "roles": {
    "title": "Papéis e permissões",
    "subtitle": "Configure papéis customizados para o tenant",
    "system": "Sistema",
    "create": "Criar papel",
    "createSuccess": "Papel criado",
    "createFailed": "Falha ao criar papel",
    "delete": "Excluir",
    "confirmDelete": "Excluir o papel {{name}}?",
    "deleteSuccess": "Papel excluído",
    "deleteFailed": "Falha ao excluir papel",
    "bindFailed": "Falha ao atualizar permissão",
    "selectPrompt": "Selecione um papel para editar permissões",
    "permissionsFor": "Permissões de {{name}}",
    "systemReadOnly": "Papéis do sistema não podem ser editados",
    "counts": "{{permissions}} permissões · {{members}} membros",
    "empty": "Nenhum papel cadastrado",
    "createTitle": "Criar papel",
    "nameLabel": "Nome do papel",
    "descriptionLabel": "Descrição (opcional)",
    "nameRequired": "Informe um nome para o papel",
    "nameDuplicate": "Já existe um papel com esse nome",
    "bindingsUnavailable": "Não foi possível carregar as permissões atuais deste papel; a edição está bloqueada para evitar inconsistência.",
    "bindingsCount": "Este papel possui {{count}} permissões vinculadas"
  },
  "permissions": {
    "matrix": "Matriz de permissões",
    "resource": "Recurso",
    "actions": {
      "create": "Criar",
      "read": "Ler",
      "update": "Atualizar",
      "delete": "Excluir",
      "approve": "Aprovar",
      "manage": "Gerenciar"
    },
    "resources": {
      "work_order": "Ordens de serviço",
      "maint_plan": "Planos de manutenção",
      "equipment": "Equipamentos",
      "user": "Usuários",
      "role": "Papéis",
      "team": "Equipe"
    }
  },
  "invitation": {
    "title": "Você foi convidado para {{tenant}}",
    "body": "{{inviter}} te convidou para o papel \"{{role}}\" como {{email}}. Aceite para entrar.",
    "accept": "Aceitar convite",
    "errorTitle": "Convite indisponível",
    "notFoundBody": "Não encontramos este convite. Verifique o link ou peça um novo para quem te convidou.",
    "expiredBody": "Este convite expirou, já foi usado ou foi revogado.",
    "requestNew": "Pedir novo convite",
    "requestNewMailtoSubject": "Preciso de um novo convite para o AxiomGO",
    "goToSignIn": "Já tenho uma conta",
    "createAccount": "Criar conta e aceitar",
    "alreadyHaveAccount": "Já tem conta?",
    "signIn": "Entrar",
    "mismatchTitle": "Este convite é para outra conta",
    "mismatchBody": "O convite foi enviado para {{invited}}. Você está conectado como {{current}}.",
    "switchAccount": "Entrar com outra conta",
    "acceptErrorUsed": "Não foi possível aceitar este convite para esta conta. Peça ajuda ao administrador.",
    "mismatchGenericBody": "O e-mail da sua conta não confere com o e-mail do convite.",
    "acceptErrorNetwork": "Não foi possível concluir agora. Tente novamente.",
    "retry": "Tentar novamente",
    "switchToInvited": "Sair e entrar com {{email}}",
    "verifyEmailBody": "Confirme o e-mail convidado na sua conta antes de aceitar. Um endereço não verificado não autoriza o aceite.",
    "revokedBody": "Este convite foi revogado. Peça um novo convite ao administrador.",
    "supersededBody": "Este convite foi substituído. Use o link do convite mais recente.",
    "usedBody": "Este convite já foi aceito. Entre com a conta que aceitou o convite.",
    "alreadyMemberBody": "Esta conta já é membro desta empresa. Entre no chat para continuar."
  },
  "signup": {
    "title": "Criar conta",
    "description": "Comece grátis em segundos",
    "submit": "Criar conta",
    "email": "E-mail",
    "name": "Nome",
    "existing": "Já tem conta?",
    "signIn": "Entrar"
  },
  "onboarding": {
    "progress": {
      "phase": {
        "profile": "Seu perfil",
        "equipment": "Base de dados",
        "plan": "Plano de manutenção",
        "team": "Equipe e materiais",
        "done": "Tudo pronto"
      },
      "eta_one": "≈ {{count}} min restante",
      "eta_other": "≈ {{count}} min restantes",
      "aria_one": "Progresso do onboarding: fase {{index}} de {{total}}, {{phase}}. Cerca de {{count}} minuto restante.",
      "aria_other": "Progresso do onboarding: fase {{index}} de {{total}}, {{phase}}. Cerca de {{count}} minutos restantes.",
      "ariaComplete": "Progresso do onboarding: fase {{index}} de {{total}}, {{phase}}."
    },
    "plan": {
      "title": "Escolha seu plano",
      "subtitle": "Comece grátis ou desbloqueie recursos avançados para sua equipe.",
      "select": "Escolher {{plan}}"
    }
  },
  "billing": {
    "accessDenied": "Somente o proprietário da conta pode ver assinatura e cobrança. Fale com ele se precisar de algo aqui.",
    "title": "Assinatura",
    "subtitle": "Plano atual: {{plan}}",
    "currentPlan": "Plano atual",
    "loading": "Carregando…",
    "planNames": {
      "b2c_personal": "Acesso integral"
    },
    "unlimited": "Ilimitado",
    "manage": {
      "title": "Gerenciar assinatura",
      "description": "Atualize cartão, baixe faturas ou cancele pelo portal Stripe.",
      "button": "Abrir portal"
    },
    "checkout": {
      "noUrl": "Stripe não retornou URL, tente novamente."
    },
    "status": {
      "active": "Ativa",
      "past_due": "Pagamento atrasado",
      "canceled": "Cancelada",
      "trialing": "Período de teste"
    },
    "quota": {
      "tokens": "Tokens / mês",
      "entities": "Entidades"
    }
  },
  "usage": {
    "title": "Uso atual",
    "tokens": "Tokens",
    "entities": "Entidades",
    "tokensQuota": "Tokens · contado na cota",
    "entitiesQuota": "Entidades · contado na cota",
    "equipment_zero": "{{n}} equipamentos",
    "equipment_one": "{{n}} equipamento",
    "equipment_other": "{{n}} equipamentos",
    "workOrders_zero": "{{n}} ordens de serviço",
    "workOrders_one": "{{n}} ordem de serviço",
    "workOrders_other": "{{n}} ordens de serviço",
    "plans_zero": "{{n}} planos",
    "plans_one": "{{n}} plano",
    "plans_other": "{{n}} planos",
    "actualLine": "Consumo real no período: {{tokens}} tokens"
  },
  "memory": {
    "updated": "Memória atualizada",
    "toggle": {
      "on": "Memória ON",
      "off": "Memória OFF",
      "ariaOn": "Memória ativada nesta conversa, toque para desativar",
      "ariaOff": "Memória desativada nesta conversa, toque para ativar",
      "titleOn": "O curador está salvando aprendizados desta conversa",
      "titleOff": "Nada desta conversa está sendo gravado na memória"
    },
    "settings": {
      "title": "Memória da operação",
      "backToChat": "Voltar para o chat",
      "searchPlaceholder": "Buscar fatos…",
      "export": "Exportar (JSON)",
      "wipe": "Apagar tudo",
      "wipeConfirm1": "Tem certeza?",
      "wipeConfirm2": "Confirmar apagar tudo",
      "loading": "Carregando…",
      "totalCount": "{{count}} fatos no total",
      "listLabel": "Lista de fatos da memória",
      "edit": "Editar",
      "delete": "Apagar",
      "save": "Salvar",
      "cancel": "Cancelar",
      "empty": "Nenhum fato na memória ainda, eles aparecem conforme você conversa.",
      "confirmDelete": "Apagar este fato?",
      "savedToast": "Fato atualizado.",
      "deletedToast": "Fato removido.",
      "wipedToast": "{{count}} fatos removidos.",
      "exportedToast": "Exportação iniciada, verifique seus downloads."
    },
    "lgpd": {
      "description": "Estes fatos foram extraídos das suas conversas pelo curador. Você pode editar, apagar ou exportar a qualquer momento (LGPD Art. 18)."
    }
  },
  "trajectory": {
    "repetitions": "{{count}} atualizações agrupadas",
    "labels": {
      "pending": "Pendente",
      "running": "Em execução",
      "done": "Concluído",
      "error": "Erro"
    },
    "steps": {
      "searching": "Buscando informações",
      "sources": "Consultando fontes",
      "analyzing": "Analisando dados",
      "tools": "Executando ação",
      "generating": "Elaborando resposta",
      "reasoning": "Raciocinando"
    },
    "expand": "Expandir",
    "collapse": "Recolher",
    "viewAll": "Ver mais {{count}}",
    "expandCard": {
      "expand": "Expandir card",
      "expandedBadge": "Card aberto em tela cheia",
      "title": {
        "web_search": "Sugestão de plano, montada pelo Axis",
        "action_cards": "Ações sugeridas",
        "proposal": "Proposta",
        "form": "Formulário",
        "kpi": "Indicadores",
        "import": "Importação",
        "task_materials": "Materiais por tarefa",
        "plan_edit": "Plano de manutenção: revisar",
        "resource_allocation": "Alocação de recursos",
        "equipment_search": "Resultado do equipamento",
        "preventive_draft": "Plano preventivo: rascunho"
      }
    }
  },
  "workOrder": {
    "operation": {
      "actualStart": "Início Real",
      "actualEnd": "Fim Real",
      "totalTime": "Tempo Total",
      "deltaPlannedVsActual": "Δ Previsto vs Real",
      "inProgress": "Em andamento"
    }
  },
  "artifacts": {
    "open": "Abrir em painel",
    "openInPanel": "Abrir no painel",
    "viewMaterials": "Ver materiais",
    "close": "Fechar painel",
    "empty": "Nenhuma informação disponível.",
    "unrenderable": "Não foi possível exibir este conteúdo.",
    "title": {
      "plan": "Plano de manutenção",
      "materials": "Lista de materiais",
      "wo": "Ordem de serviço",
      "import": "Importação",
      "citation": "Fonte",
      "insights": "Indicadores",
      "schedule": "Cronograma"
    },
    "citation": {
      "openLink": "Abrir link original"
    },
    "materials": {
      "empty": "Nenhum material listado neste plano.",
      "code": "Código",
      "name": "Nome",
      "qty": "Qtd",
      "unit": "Unidade"
    },
    "wo": {
      "status": "Status",
      "priority": "Prioridade",
      "equipment": "Equipamento",
      "location": "Localização",
      "team": "Equipe",
      "plannedStart": "Início Previsto",
      "plannedEnd": "Fim Previsto",
      "plannedDuration": "Duração Prevista",
      "operations": "Operações",
      "operationSequence": "Seq."
    },
    "insights": {
      "loadingChart": "Carregando gráfico...",
      "blockFailed": "Não foi possível exibir este bloco.",
      "gallery": {
        "title": "Galeria do Axis Insights",
        "description": "Todos os blocos do painel de indicadores, em todos os estados, a partir de exemplos fixos. Referência dos testes visuais; não é tela do produto.",
        "empty": "Nenhum bloco na galeria ainda."
      },
      "panel": {
        "refresh": "Atualizar painel",
        "refreshPrompt": "Atualize o painel \"{{title}}\" com os dados de agora",
        "pin": "Fixar painel"
      },
      "quality": {
        "title": "Atenção à qualidade do dado"
      },
      "kpi": {
        "noValue": "sem valor: amostra insuficiente",
        "vs": "vs {{period}}",
        "direction": {
          "up": "subiu {{delta}}",
          "down": "caiu {{delta}}",
          "flat": "estável {{delta}}"
        }
      },
      "chart": {
        "retry": "Tentar de novo",
        "retryPrompt": "Desenhe de novo o gráfico \"{{title}}\"",
        "failed": "Este gráfico não pôde ser desenhado.",
        "aria": "Gráfico: {{title}}. {{summary}}"
      },
      "table": {
        "sortAsc": "Ordenar crescente por {{column}}",
        "sortDesc": "Ordenar decrescente por {{column}}",
        "page": "Página {{page}} de {{total}}",
        "prev": "Página anterior",
        "next": "Próxima página",
        "rows": "{{shown}} de {{total}} linhas"
      },
      "tools": {
        "title": "O que a IA executou",
        "params": "Parâmetros",
        "result": "Resultado",
        "noParams": "Sem parâmetros.",
        "summary": "Resultado: {{resumo}}",
        "state": {
          "preparing": "preparando",
          "running": "executando",
          "done": "concluído",
          "error": "falhou"
        }
      },
      "chips": {
        "aria": "Sugestões de pergunta",
        "indicators": "Perguntas prontas",
        "indicatorsHint": "Perguntas prontas sobre indicadores e auditoria dos dados"
      },
      "report": {
        "severity": {
          "high": "alta",
          "medium": "média",
          "info": "informativo"
        },
        "detections": "Detecções",
        "method": "Método: {{name}} · n={{n}}",
        "trendNotDate": "é tendência, não previsão de data"
      }
    }
  },
  "citations": {
    "tooltip": {
      "viewSource": "Abrir no painel"
    },
    "unavailable": "Fonte indisponível",
    "loading": "Carregando fonte…",
    "error": "Não foi possível carregar a fonte.",
    "retry": "Tentar novamente",
    "typeLabel": {
      "doc": "Documento",
      "wo": "Ordem de serviço",
      "norma": "Norma técnica",
      "equip": "Equipamento"
    },
    "wo": {
      "unavailable": "Ordem de serviço indisponível no momento.",
      "notFound": "Ordem de serviço não encontrada."
    }
  },
  "plans": {
    "export": {"plan": "Plano", "equipment": "Equipamento", "description": "Descrição", "strategy": "Estratégia", "interval": "Intervalo", "nextDue": "Próxima data", "tasks": "Tarefas", "origin": "Origem do plano", "sequence": "Sequência", "instruction": "Instrução", "duration": "Duração (min)", "notRecorded": "Não registrado", "plansSheet": "Planos", "tasksSheet": "Tarefas",
      "units": {"days": "dias", "hours": "horas", "km": "km", "cycles": "ciclos"},
      "origins": {"user": "Usuário", "ai_proposal": "Proposta de IA", "ai_auto": "IA automática"}, "source": "Referência da fonte", "page": "Página", "citation": "Trecho da fonte", "grounding": "Fundamentação", "groundingLabels": {"verified": "Citação verificada", "ai_unverified": "Sugestão de IA não verificada"}},
    "cadence": {
      "unavailable": "Frequência indisponível",
      "notScheduledAutomatically": "Sem programação automática"
    },
    "bulk": {
      "trigger": "Ativar planos inativos ({{count}})",
      "groupLabel": "Ativação em lote dos planos",
      "reviewTitle_one": "Ativar {{count}} plano inativo desta lista?",
      "reviewTitle_other": "Ativar {{count}} planos inativos desta lista?",
      "reviewBody": "Cada plano passa pela ativação normal, com as mesmas validações e permissões. Planos já ativos não são alterados.",
      "confirm": "Confirmar ativação",
      "cancel": "Cancelar",
      "progress": "Ativando: {{done}} de {{total}}",
      "resultAll_one": "O plano foi ativado.",
      "resultAll_other": "Os {{count}} planos foram ativados.",
      "resultMixed": "{{confirmed}} ativados, {{refused}} recusados, {{pending}} sem confirmação.",
      "refused": "{{tag}}: recusado. {{reason}}",
      "pending": "{{tag}}: sem confirmação. Verifique antes de repetir.",
      "retry": "Verificar e tentar de novo ({{count}})",
      "dismiss": "Fechar"
    },
    "title": "Planos Preventivos",
    "filterPlaceholder": "Filtrar por tag ou número (PLA-…)",
    "strategyFilterLabel": "Filtrar por estratégia",
    "statusFilterLabel": "Filtrar por status",
    "allStrategies": "Todas estratégias",
    "allStatuses": "Todos",
    "activeOnly": "Ativos",
    "inactiveOnly": "Inativos",
    "noResults": "Nenhum plano encontrado.",
    "taskCount_zero": "0 tarefas",
    "taskCount_one": "{{count}} tarefa",
    "taskCount_other": "{{count}} tarefas",
    "tasksUnknown": "… tarefas",
    "tasksHeading": "Tarefas",
    "tasksEmpty": "Plano sem tarefas, incompleto.",
    "detailTitle": "Detalhe do plano",
    "detailError": "Não foi possível carregar o detalhe do plano.",
    "field": {
      "strategy": "Estratégia",
      "interval": "Intervalo",
      "origin": "Origem",
      "active": "Ativo"
    },
    "col": {
      "plan": "Plano",
      "equipment": "Equipamento",
      "description": "Descrição",
      "interval": "Intervalo",
      "nextDue": "Próxima",
      "tasks": "Tarefas"
    }
  },
  "horizon": {
    "title": "Horizonte preventivo (52 semanas)",
    "subtitle": "Planos ativos por semana ISO. Somente leitura.",
    "empty": "Nenhum plano agendado no horizonte.",
    "weekDetail": "Semana {{week}}, {{count}} plano(s)"
  },
  "preventiveDue": {
    "title": "Planos preventivos vencendo",
    "summary": "{{count}} plano(s) vencendo nos próximos {{days}} dias.",
    "cta": "Revisar e gerar OS",
    "dismiss": "Dispensar"
  },
  "validator": {
    "fallback": {
      "phantomTag": "Não foi possível confirmar com segurança os equipamentos no sistema nesta resposta. Por favor, refine a consulta, por exemplo, informe um tag específico, uma planta ou uma localização, e tente novamente.",
      "enforceExhausted": "Não consegui gerar uma resposta confiável para esta solicitação agora. Tente reformular o pedido ou contate o suporte."
    }
  },
  "voice": {
    "errors": {
      "notSupported": "Comando de voz não suportado neste navegador.",
      "notAllowed": "Permissão de microfone negada.",
      "noSpeech": "Não ouvi nada. Tente novamente.",
      "audioCapture": "Não foi possível acessar o microfone.",
      "aborted": "Captura de voz interrompida.",
      "network": "Falha de rede no reconhecimento de voz.",
      "serviceNotAllowed": "Serviço de voz indisponível.",
      "languageNotSupported": "Idioma não suportado para voz.",
      "synthesisFailed": "Falha ao narrar a resposta.",
      "unknown": "Erro de voz desconhecido."
    },
    "provenance": {
      "suppressedUnbackedIdentifiers": "Alguns identificadores não confirmados foram omitidos da narração."
    },
    "listening": "Parar e enviar",
    "pushToTalk": "Falar um comando",
    "stopNarration": "Parar narração",
    "permissionLost": "Permissão de microfone perdida",
    "disambiguateOp": "Qual operação? {{options}}",
    "enable": "Ativar voz",
    "disable": "Desativar voz",
    "narrationTruncated": "Narração resumida. Veja a resposta completa na tela.",
    "disabledMeeting": "Microfone indisponível durante a gravação da reunião"
  },
  "equipmentRegistration": {
    "commit": {
      "saving": "Salvando…",
      "offline": "Sem conexão com o servidor. Nada foi gravado ainda.",
      "tagTaken": "A TAG {{tag}} já existe nesta planta. Escolha outra.",
      "stale": "Os dados mudaram, revise esta etapa.",
      "forbidden": "Seu perfil não tem permissão para cadastrar equipamentos.",
      "planLimit": "Você atingiu o limite de equipamentos do seu plano.",
      "refusedTitle": "Cadastro não gravado",
      "savedTitle": "Cadastro salvo",
      "wait": "O servidor pediu uma pausa. Tente de novo em {{segundos}} s.",
      "waitShort": "Muitas tentativas seguidas. Aguarde um instante e tente de novo.",
      "syncFailed": "Não consegui salvar o andamento do cadastro antes da sua mensagem. Ela continua no campo; tente enviar de novo."
    },
    "identity": {
      "title": "Qual é a marca, o modelo e a descrição do equipamento?",
      "hint": "Sugerimos uma tag a partir da marca e do modelo, você pode aceitá-la ou digitar a sua no próximo passo.",
      "manufacturerPlaceholder": "Marca (ex.: Krones)",
      "modelPlaceholder": "Modelo (ex.: Modulfill VFS)",
      "descriptionPlaceholder": "Descrição completa (ex.: compressor de parafuso da sala de utilidades)",
      "titleSeeded": "Confirme a marca e o modelo do equipamento.",
      "hintSeeded": "Trouxemos a marca e o modelo que você já informou. Revise, ajuste se precisar e confirme; a tag vem no próximo passo.",
      "submitSeeded": "Confirmar"
    },
    "intro": {
      "title": "Vamos cadastrar esse equipamento?",
      "body": "Para cadastrar {{manufacturer}} {{model}} preciso de Planta e Localização.",
      "requirements": "Vou precisar da planta e da localização onde ele fica.",
      "continue": "Continuar"
    },
    "plant": {
      "title": "Em qual planta esse equipamento fica?",
      "loading": "Carregando plantas...",
      "error": "Erro ao carregar plantas.",
      "newPlant": "Criar nova planta",
      "newPlantHint": "Informe o nome da nova planta. O código pode ser gerado automaticamente.",
      "autoCodeLabel": "Gerar código automaticamente",
      "codePlaceholder": "Código (ex.: PLT-01)",
      "namePlaceholder": "Nome da planta",
      "countryPlaceholder": "País (opcional)",
      "currencyPlaceholder": "Moeda",
      "createPlant": "Criar planta",
      "errorForbidden": "Sem permissão para ver as plantas. Crie uma nova abaixo."
    },
    "location": {
      "title": "E em qual localização, dentro da planta?",
      "loading": "Carregando localizações...",
      "error": "Erro ao carregar localizações.",
      "noLocations": "Esta planta ainda não tem localizações. Crie a primeira abaixo.",
      "newLocation": "Criar nova localização",
      "autoCodeLabel": "Gerar código automaticamente",
      "codePlaceholder": "Código (ex.: LOC-A)",
      "descriptionPlaceholder": "Descrição (opcional)",
      "createLocation": "Criar localização"
    },
    "tag": {
      "title": "Como você quer identificar (a tag)?",
      "hint": "A tag identifica o equipamento de forma única na sua planta.",
      "autoPreview": "Tag sugerida: {{tag}}",
      "generateAuto": "Gerar automaticamente",
      "haveTag": "Já tenho uma tag",
      "placeholder": "Ex.: KRN-001",
      "submit": "Usar esta tag",
      "sequenceOnConfirm": "(gerada ao confirmar)"
    },
    "criticality": {
      "title": "Qual a criticidade dele: A, B ou C?",
      "hint": "Define a prioridade de manutenção. Padrão: C (Normal).",
      "optionA": "Crítico",
      "descA": "Se parar, a produção para",
      "optionB": "Importante",
      "descB": "Se parar, afeta parte da produção",
      "optionC": "Normal",
      "descC": "Sem impacto imediato na produção",
      "confirm": "Confirmar criticidade"
    },
    "confirming": {
      "title": "Está tudo certo para cadastrar?",
      "equipment": "Equipamento: {{manufacturer}} {{model}}",
      "tag": "Tag: {{tag}}",
      "criticality": "Criticidade: {{criticality}}",
      "plant": "Planta (existente): {{name}}",
      "plantFallback": "planta já selecionada",
      "newPlant": "Nova planta: {{code}} ({{name}})",
      "location": "Localização (existente): {{name}}",
      "locationFallback": "localização já selecionada",
      "newLocation": "Nova localização: {{code}}",
      "confirm": "Confirmar cadastro"
    },
    "summary": {
      "start": "Cadastrar equipamento: {{value}}.",
      "startBare": "Cadastrar equipamento.",
      "equipment": "Equipamento: {{value}}.",
      "plant": "Planta: {{value}}.",
      "plantBare": "Planta selecionada.",
      "newPlant": "Nova planta: {{value}}.",
      "location": "Localização: {{value}}.",
      "locationBare": "Localização selecionada.",
      "newLocation": "Nova localização: {{value}}.",
      "tagAuto": "Tag gerada automaticamente.",
      "tagManual": "Tag manual: {{value}}.",
      "criticality": "Criticidade: {{value}}.",
      "confirm": "Confirmar cadastro do equipamento.",
      "cancel": "Cancelar cadastro do equipamento.",
      "back": "Voltar ao passo anterior.",
      "generic": "Ação de cadastro de equipamento."
    },
    "done": {
      "title": "Equipamento cadastrado com sucesso.",
      "railBody": "Planta, localização e equipamento cadastrados.",
      "railBodyLocationEquipment": "Localização nova cadastrada na planta que já existia.",
      "railBodyEquipmentOnly": "Na planta e localização que já existiam.",
      "railQuestion": "Você decide o próximo passo. Quer montar o plano preventivo do equipamento ou abrir uma ordem corretiva para uma falha atual?",
      "actions": {
        "plan": {
          "label": "Criar plano preventivo",
          "message": "Quero montar um plano de manutenção preventiva para o equipamento {{tag}}"
        },
        "corrective": {
          "label": "Abrir ordem corretiva",
          "message": "Abrir ordem corretiva para o equipamento {{tag}}"
        },
        "view": {
          "label": "Ver o equipamento",
          "message": "Mostrar o equipamento {{tag}}"
        }
      }
    },
    "cancelled": {
      "title": "Cadastro cancelado",
      "body": "Nenhum dado foi gravado. Você pode recomeçar quando quiser."
    },
    "common": {
      "back": "Voltar",
      "cancel": "Cancelar cadastro",
      "retry": "Tentar novamente"
    }
  },
  "equipmentSearch": {
    "form": {
      "equipmentType": "Tipo de equipamento",
      "equipmentTypePlaceholder": "Ex.: Compressor",
      "manufacturer": "Marca",
      "manufacturerPlaceholder": "Ex.: Atlas Copco",
      "model": "Modelo",
      "modelPlaceholder": "Ex.: GA37",
      "submit": "Buscar plano do fabricante"
    },
    "card": {
      "title": "Meus equipamentos",
      "count": "{{count}} equipamentos",
      "count_one": "{{count}} equipamento",
      "count_other": "{{count}} equipamentos",
      "empty": "Nenhum equipamento encontrado.",
      "hasMore": "Mostrando {{returned}} de {{total}}.",
      "listMoreAria": "{{label}} (página {{page}})",
      "viewHistory": "Ver histórico",
      "viewHistoryQuery": "Histórico do equipamento {{tag}}",
      "searchManufacturer": "Buscar dados na WEB",
      "searchManufacturerQuery": "Me fale do {{equipment}}",
      "createWorkOrder": "Criar O.S",
      "details": "Detalhes do equipamento"
    },
    "criticality": {
      "A": "A · Crítico",
      "B": "B · Importante",
      "C": "C · Normal"
    },
    "optionalSuffix": " (opcional)"
  },
  "planDetail": {
    "active": "Ativo",
    "inactive": "Inativo",
    "strategy": "Estratégia",
    "interval": "Intervalo",
    "nextDue": "Próxima execução",
    "counts": "Tarefas / materiais",
    "tasksHeading": "Tarefas",
    "tasksEmpty": "Plano sem tarefas.",
    "materialsHeading": "Materiais"
  },
  "notificationDetailing": {
    "resources": {
      "team": "Equipe",
      "specialty": "Especialidade (da equipe)",
      "technician": "Técnico",
      "select": "Selecione",
      "loadError": "Não foi possível carregar equipes ou técnicos. Tente novamente."
    },
    "missingLabel": "Falta preencher:",
    "plannedStart": "Data planejada",
    "plannedStartTime": "Hora (opcional)",
    "timeWillBeAssumed": "Sem hora: o sistema assume o início do expediente e mostra a hora para você confirmar.",
    "timeAssumed": "Hora assumida: início do expediente ({{time}}). Confirme ou altere antes de salvar.",
    "errors": {
      "sendFailed": "Não foi possível enviar. Verifique a conexão e tente de novo.",
      "descriptionRequired": "Informe a descrição da operação; apenas espaços não são válidos.",
      "pastDate": "Escolha uma data futura.",
      "invalidDate": "Data inválida."
    },
    "operationTitle": "Operação {{sequence}}",
    "operationsField": "Operações",
    "missingInOperation": "{{field}} (operação {{sequence}})",
    "description": "Descrição",
    "duration": "Tempo planejado",
    "durationUnit": "Unidade",
    "unit": {
      "MINUTES": "Minutos",
      "HOURS": "Horas",
      "DAYS": "Dias"
    },
    "technicians": "Nº de técnicos",
    "condition": "Condição de instalação",
    "conditionPlaceholder": "Não informada",
    "systemCondition": {
      "OPERATING": "Máquina rodando",
      "PARTIAL_STOP": "Parada parcial",
      "FULL_STOP": "Parada total"
    },
    "newOperation": "Nova operação",
    "addOperation": "Adicionar operação",
    "save": "Salvar e sair",
    "stop": "Parar OS"
  },
  "operationsPanel": {
    "materials": {
      "planned": "Materiais planejados",
      "unlinked": "Sem operação vinculada",
      "unavailable": "Operação vinculada indisponível"
    },
    "defaultInspection": "Inspecionar e diagnosticar falha relatada no equipamento",
    "plannedTime": "Tempo planejado: {{time}}",
    "plannedStart": "Início planejado: {{date}}",
    "technicianLabel": "Técnico: {{name}}",
    "plannedDuration": {
      "hours": "{{hours}} h",
      "minutes": "{{minutes}} min",
      "hoursMinutes": "{{hours}} h {{minutes}} min"
    },
    "systemConditionLabel": "Condição do sistema: {{condition}}",
    "systemCondition": {
      "OPERATING": "Máquina rodando",
      "PARTIAL_STOP": "Parada parcial",
      "FULL_STOP": "Parada total"
    },
    "actions": {
      "assignTechnician": "Atribuir técnico",
      "addMaterial": "Adicionar material",
      "addOperation": "Adicionar mais operações",
      "closeOrder": "Encerrar a ordem",
      "reviewClosure": "Revisar encerramento da ordem",
      "confirmMaterialConsumption": "Confirmar consumo de material",
      "start": "Iniciar",
      "pause": "Pausar",
      "resume": "Retomar",
      "finishOperation": "Encerrar operação"
    },
    "missingLabel": "Falta: {{items}}",
    "missing": { "technician": "técnico", "material_optional": "material (opcional)" },
    "closeOperation": {
      "title": "Operação {{operation}}: o que foi feito?",
      "cause": "Causa (ISO 14224)",
      "selectCause": "Selecione a causa",
      "executedBy": "Quem executou (opcional)",
      "executedByRequired": "Quem executou (obrigatório)",
      "team": "Time: {{name}}",
      "activeTime": "Tempo ativo {{time}} · calculado, sem digitar",
      "openingTime": "Tempo ao abrir encerramento {{time}}",
      "note": "O que foi feito",
      "noteMinimum": "{{count}}/{{minimum}} caracteres (mínimo)",
      "noteCount": "{{count}} caracteres",
      "back": "Voltar",
      "submit": "Encerrar operação {{operation}}"
    },
    "pending": {
      "title": "A operação ainda está aberta.",
      "description": "O que você quer fazer?"
    },
    "reservedMaterial": {
      "title": "Revisar materiais reservados",
      "description": "Confira os materiais reservados e as quantidades selecionadas."
    },
    "closeOrder": {
      "title": "Revisão da ordem",
      "note": "O que foi feito",
      "description": "Confira a ordem e as operações antes de continuar."
    },
    "closed": { "title": "Ordem encerrada" }
  },
  "workOrderDetail": {
    "planning": {
      "duration": "Duração da operação",
      "plannedMinutes": "Tempo previsto",
      "team": "Equipe planejada",
      "specialty": "Especialidade",
      "technician": "Técnico planejado",
      "performedBy": "Execução registrada",
      "unitUnknown": "{{value}} (unidade não informada)",
      "units": {
        "HOURS": "{{value}} h",
        "MINUTES": "{{value}} min",
        "DAYS": "{{value}} dias"
      }
    },
    "organization": {
      "condition": "Condição",
      "plant": "Planta",
      "team": "Equipe",
      "noTeam": "Sem equipe",
      "unknown": "Não informada"
    },
    "completionActions": {
      "open": {
        "label": "Nova OS corretiva",
        "message": "Abrir ordem corretiva para o equipamento {{tag}}"
      },
      "view": {
        "label": "Ver Equipamentos",
        "message": "Mostrar o equipamento {{tag}}"
      },
      "plan": {
        "label": "Gerar plano preventivo",
        "message": "Quero montar um plano de manutenção preventiva para o equipamento {{tag}}"
      }
    },
    "priority": "Prioridade",
    "type": "Tipo",
    "scheduledStart": "Início planejado",
    "scheduledEnd": "Fim planejado",
    "numberColumn": "OS",
    "updatedAt": "Atualizado em",
    "descriptionHeading": "Descrição",
    "notificationHeading": "Notificação vinculada",
    "operationsHeading": "Operações",
    "operationsEmpty": "OS sem operações.",
    "componentsHeading": "Componentes",
    "status": {
      "draft": "Rascunho",
      "planned": "Planejada",
      "in_progress": "Em andamento",
      "released": "Liberada",
      "technically_complete": "Encerrada tecnicamente",
      "completed": "Concluída",
      "canceled": "Cancelada",
      "desconhecido": "Status desconhecido"
    },
    "opStatus": {
      "pending": "Pendente",
      "in_progress": "Em andamento",
      "completed": "Concluída",
      "paused": "Pausada",
      "cancelled": "Cancelada",
      "desconhecido": "Status desconhecido"
    },
    "preventiveNormalPriority": "Normal",
    "priorityLevel": {
      "critical": "Emergencial",
      "high": "Urgente",
      "medium": "Importante",
      "low": "Baixa",
      "desconhecido": "Prioridade desconhecida"
    },
    "unit": {
      "pc_one": "un",
      "pc_other": "un",
      "lt": "L",
      "kg": "kg",
      "m": "m"
    },
    "woType": {
      "corrective": "Corretiva",
      "preventive": "Preventiva",
      "predictive": "Preditiva",
      "improvement": "Melhoria",
      "desconhecido": "Tipo desconhecido"
    }
  },
  "planEdit": {
    "frequencyUnrecognized": "Frequência não reconhecida, defina",
    "frequencyConditionBased": "Tarefa por condição: a fonte não dá intervalo fixo. Defina de quanto em quanto tempo verificar.",
    "sourceFrequency": "Frequência no plano original",
    "title": "Plano de Manutenção: revisar",
    "col": {
      "index": "Nº",
      "tarefa": "Tarefa",
      "inicioCiclo": "Início de Ciclo",
      "frequencyUnit": "Unidade da frequência",
      "origem": "Origem"
    },
    "confirm": "Confirmar plano",
    "cancel": "Voltar",
    "error": {
      "descriptiveFrequencyInvalid": "Não foi possível validar a frequência descritiva recebida.",
      "dateInvalid": "Data inválida, use dd/mm/aaaa",
      "unitRequired": "Escolha a unidade da frequência",
      "required": "Obrigatório"
    },
    "freqUnit": {
      "HOURS": "horas",
      "DAYS": "dias",
      "WEEKS": "semanas",
      "MONTHS": "meses",
      "YEARS": "anos",
      "CYCLES": "ciclos"
    },
    "replicateDate": "Replicar esta data nas demais tarefas",
    "replicate": "Replicar",
    "taskPlaceholder": "Descreva a tarefa",
    "duplicateBadge": "Tarefa repetida",
    "dataNoPassado": "Início no passado",
    "requiredField": "obrigatório",
    "requiredCount": "{{count}} linha(s) com campos obrigatórios em branco",
    "requiredJump": "Ir para a primeira",
    "bulkDate": {
      "label": "Início do ciclo para todas as linhas",
      "apply": "Aplicar às vazias"
    },
    "empty": {
      "linha": "Nenhuma tarefa ainda. Adicione abaixo ou volte e peça a busca do plano.",
      "confirmBloqueado": "Não há tarefa para confirmar"
    },
    "source": {
      "page": "p. {{page}}",
      "pageAria": "Página {{page}} do manual",
      "quoteSummary": "Trecho do manual"
    },
    "provenance": {
      "fabricante": {
        "rotulo": "Fabricante",
        "ajuda": "Extraído do manual do fabricante pelo Axis. Confira no documento original."
      },
      "cliente": {
        "rotulo": "Seu plano",
        "ajuda": "Tarefa do plano que você já usa, como está na sua planilha."
      },
      "analogia": {
        "rotulo": "Analogia",
        "ajuda": "Veio do documento do fabricante de outro modelo da mesma arquitetura. Confira antes de aplicar."
      },
      "pratica_setor": {
        "rotulo": "Prática de mercado",
        "ajuda": "Prática consolidada para esta classe de equipamento, e não documento do fabricante. Confira antes de aplicar."
      },
      "inferencia": {
        "rotulo": "Inferido pela máquina",
        "ajuda": "Deduzido a partir da arquitetura da máquina, e não documento do fabricante. Confira antes de aplicar."
      },
      "norma": {
        "rotulo": "Norma técnica",
        "ajuda": "Exigida por norma técnica (NR, ISO) para este tipo de equipamento, e não pelo documento do fabricante. Confira a norma citada antes de aplicar."
      }
    }
  },
  "teamRoster": {
    "title": "Cadastro de Equipe",
    "col": {
      "name": "Nome",
      "role": "Papel",
      "email": "E-mail",
      "personnelNumber": "Matrícula",
      "specialties": "Especialidades"
    },
    "role": {
      "placeholder": "Selecionar",
      "mechanic": "Mecânico",
      "electrician": "Eletricista",
      "instrumentist": "Instrumentista",
      "electromechanic": "Eletromecânico",
      "lubricator": "Lubrificador",
      "welder": "Soldador",
      "boilermaker": "Caldeireiro",
      "refrigeration_technician": "Técnico de Refrigeração e Climatização",
      "automation_technician": "Técnico de Automação",
      "predictive_analyst": "Analista de Preditiva (Vibração e Termografia)",
      "civil_maintainer": "Manutentor Civil",
      "hydraulics_pneumatics_technician": "Técnico de Hidráulica e Pneumática",
      "operator": "Operador",
      "planner": "Planejador (PCM)",
      "supervisor": "Supervisor",
      "helper": "Auxiliar de Manutenção"
    },
    "specialtiesPlaceholder": "Separe por vírgula",
    "addRow": "Adicionar técnico",
    "removeRow": "Remover linha",
    "confirm": "Concluir equipe",
    "error": {
      "roleRequired": "Escolha o papel do técnico"
    }
  },
  "materialsInventory": {
    "title": "Inventário de Materiais",
    "col": {
      "code": "Código do Material",
      "description": "Descrição do Material",
      "quantity": "Inserir Inventário",
      "unit": "Unidade"
    },
    "addRow": "Adicionar material",
    "removeRow": "Remover linha",
    "confirm": "Concluir materiais"
  },
  "alerts": {
    "correctiveEmergency": {
      "title": "Corretiva emergencial em {{equipment}}",
      "titleWithoutEquipment": "Corretiva emergencial registrada",
      "body": "Uma corretiva emergencial foi aberta no equipamento {{equipment}}.",
      "bodyWithoutEquipment": "Uma corretiva emergencial foi aberta.",
      "report": "Relato: {{description}}",
      "note": "Nota {{number}}.",
      "action": "A equipe precisa avaliar a parada agora."
    },
    "bell": {
      "aria": "Avisos",
      "ariaWithCount_one": "Avisos, {{count}} não lido",
      "ariaWithCount_other": "Avisos, {{count}} não lidos",
      "title": "Avisos"
    },
    "panel": {
      "aria": "Painel de avisos",
      "title": "Avisos"
    },
    "markRead": "marcar como lido",
    "markAllRead": "marcar todas como lidas",
    "beyondPage_one": "+{{count}} não lido fora desta lista",
    "beyondPage_other": "+{{count}} não lidos fora desta lista",
    "empty": "Nenhum aviso por aqui.",
    "loading": "Carregando avisos...",
    "retry": "Tentar de novo",
    "error": {
      "load": "Não consegui carregar seus avisos."
    }
  },
  "osNotification": {
    "alertBody": "Toque para ver no AxiomGO.",
    "planReadyTitle": "Plano de manutenção pronto",
    "planReadyBody": "O plano do {{label}} está pronto para revisão."
  },
  "nps": {
    "pulse": {
      "title": "Como foi criar seu primeiro plano?",
      "subtitle": "De 0 a 10, o quanto você recomendaria o AxiomGO para outro profissional de manutenção?",
      "scoreGroupLabel": "Nota de 0 a 10",
      "scoreLabel": "Nota {{score}}",
      "anchorLow": "Não recomendaria",
      "anchorHigh": "Recomendaria muito",
      "commentLabel": "Comentário opcional",
      "commentPlaceholder": "Quer contar o porquê? (opcional)",
      "sending": "Enviando sua resposta...",
      "error": "Não consegui registrar sua resposta. Tente enviar de novo.",
      "submit": "Enviar resposta"
    }
  },
  "taskMaterials": {
    "stockSuggestionNotice": "O saldo sugerido usa a demanda agrupada do plano por código e unidade. Não é estoque físico confirmado. Revise ou limpe o valor; nada é gravado antes da confirmação.",
    "stockSuggested": "Demanda do plano · sugestão",
    "stockDeclared": "Valor informado",
    "stockBlocked": "Sem sugestão: este código aparece em mais de um lugar com quantidade ausente ou inválida, unidade diferente ou desconhecida, ou repetido na mesma tarefa. Corrija ou informe o saldo.",
    "col": {
      "code": "Código",
      "description": "Descrição",
      "quantity": "Qtd.",
      "unit": "Unidade",
      "saldoInicial": "Saldo inicial"
    },
    "semMaterial": "Nenhum material nesta tarefa.",
    "addRow": "+ incluir material nesta tarefa",
    "deleteRow": "Excluir",
    "regiao": "Materiais por tarefa",
    "invalidUnit": "Escolha uma unidade suportada: {{units}}."
  },
  "materialPicker": {
    "title": "Quais materiais a operação {{operation}} vai usar?",
    "search": "Pesquisar código, descrição, fabricante ou peça",
    "searchServer": "Buscar no servidor",
    "shown": "{{shown}} de {{total}} mostrados",
    "stock": "Em estoque: {{count}} {{unit}}",
    "noStock": "Sem estoque disponível",
    "quantity": "Quantidade a reservar",
    "selected": "{{count}} materiais marcados",
    "add": "Adicionar {{count}} materiais",
    "selected_one": "{{count}} material marcado",
    "selected_other": "{{count}} materiais marcados",
    "add_one": "Adicionar {{count}} material",
    "add_other": "Adicionar {{count}} materiais",
    "expand": "Abrir detalhes",
    "collapse": "Recolher detalhes",
    "expandAll": "Abrir todos",
    "collapseAll": "Recolher todos",
    "balance": "Saldo",
    "reserved": "Reservado",
    "available": "Disponível",
    "empty": "Nenhum material cadastrado no estoque.",
    "noResults": "Nada encontrado para esta pesquisa.",
    "register": "Cadastrar mais materiais",
    "registerMessage": "Quero cadastrar mais materiais."
  },
  "importFlow": {
    "title": "Importação de planilha",
    "refusal": "Falta resolver: {{field}}",
    "choosingPath": {
      "body": "Dois caminhos: enviar uma planilha sua, ou baixar as planilhas modelo para preencher e voltar depois."
    },
    "awaitingFile": {
      "body": "Envie a planilha pelo anexo. Aceito .xlsx, .xls e .csv de até 50 MB."
    },
    "analyzing": {
      "body": "Estou lendo sua planilha..."
    },
    "reviewing": {
      "body": "Revise o que eu entendi de cada aba e resolva as pendências antes de confirmar."
    },
    "importing": {
      "body": "Importando os dados...",
      "retrying": "Tive um tropeço e estou tentando de novo..."
    },
    "completed": {
      "body": "Importação concluída: {{imported}} itens entraram."
    },
    "completedWithPending": {
      "body": "Importação concluída com pendências: {{imported}} entraram e {{failed}} linhas ficaram de fora."
    },
    "failed": {
      "body": "Não consegui importar: {{reason}}. Nada foi gravado."
    },
    "canceled": {
      "body": "Importação cancelada. Nada foi gravado.",
      "templates": "Planilhas modelo preparadas. Preencha e volte para enviar."
    },
    "expired": {
      "body": "Esta importação ficou parada tempo demais e expirou. Envie a planilha de novo."
    },
    "sheet": {
      "suggested": "parece {{entity}},",
      "unrecognized": "não reconhecida,",
      "pending": "aguardando sua decisão",
      "accepted": "vai entrar",
      "ignored": "fora da importação",
      "expired": "decisão expirada"
    },
    "actions": {
      "chooseImport": "Enviar planilha",
      "chooseTemplates": "Baixar modelos",
      "resolvePending": "Cadastrar o que falta",
      "replaceFile": "Trocar planilha",
      "cancel": "Cancelar"
    }
  },
  "resourceAllocation": {
    "suggestion": {
      "specialty_match": "sugestão: competência declarada",
      "role_match": "sugestão: pelo papel na equipe",
      "general_fallback": "sugestão: atende geral",
      "no_match": "sem técnico com esta especialidade",
      "user_edit": "sua escolha"
    },
    "suggestionAria": "Origem da alocação"
  },
  "teamPicker": {
    "title": "Qual time cuida desta ordem?",
    "emptyNoCreate": "Não há time cadastrado e você não tem permissão para cadastrar. Peça a um administrador.",
    "areaFilter": "Filtrar por área",
    "allAreas": "Todas",
    "openOrders_zero": "{{count}} ordens abertas",
    "openOrders_one": "{{count}} ordem aberta",
    "openOrders_other": "{{count}} ordens abertas",
    "empty": "Ainda não há time cadastrado para esta planta.",
    "register": "Cadastrar time",
    "confirm": "Confirmar time",
    "form": {
      "name": "Nome do time",
      "area": "Área",
      "nameHint": "Ex.: Mecânica Turno A",
      "areaHint": "Ex.: Hidráulica",
      "areaPlaceholder": "Escolha a área",
      "cancel": "Cancelar",
      "submit": "Cadastrar e escolher"
    }
  },
  "technicianPicker": {
    "title": "Quem vai executar a operação {{operation}}?",
    "teamFilter": "Filtrar por equipe",
    "allTeams": "Todos",
    "search": "Pesquisar técnicos",
    "openOrders_one": "{{count}} ordem aberta",
    "openOrders_other": "{{count}} ordens abertas",
    "selected_one": "{{count}} técnico marcado",
    "selected_other": "{{count}} técnicos marcados",
    "register": "Cadastrar novo técnico",
    "form": {
      "name": "Nome",
      "role": "Papel",
      "team": "Equipe",
      "noTeam": "Sem equipe",
      "email": "E-mail (opcional)",
      "personnelNumber": "Matrícula (opcional)",
      "cancel": "Cancelar",
      "submit": "Cadastrar e marcar"
    },
    "assign_one": "Atribuir {{count}} técnico",
    "assign_other": "Atribuir {{count}} técnicos"
  },
  "confirmDialog": {
    "title": "Confirmar ação",
    "confirm": "Confirmar"
  },
  "auris": {
    "menu": {
      "gravarReuniao": "Gravar reunião"
    },
    "modal": {
      "titulo": "Gravar reunião",
      "aviso": "O microfone do aparelho vai captar a conversa da sala. O áudio não é guardado: só a transcrição fica registrada, e é ela que vira a ata.",
      "participantes": "Quantas pessoas estão na sala?",
      "assunto": "Assunto (opcional)",
      "aceite": "Avisei as pessoas da sala que a conversa vai ser gravada.",
      "gravar": "Começar a gravar"
    },
    "barra": {
      "gravando": "Gravando a reunião. O áudio não é guardado.",
      "encerrando": "Encerrando e gerando a ata...",
      "blocos": "{{count}} trechos enviados",
      "furada": "Um trecho não subiu. A gravação vai ficar incompleta.",
      "interrompida": "A gravação parou no servidor. O que já foi falado está salvo; o resto não.",
      "continuar": "Continuar em uma nova gravação",
      "encerrar": "Encerrar"
    },
    "card": {
      "titulo": "Ata da reunião",
      "parcial": "A gravação foi interrompida antes do fim. Parte da conversa não foi registrada.",
      "parcialAosMinutos": "Ata parcial: gravação interrompida aos {{minutos}} minutos. Parte da conversa não foi registrada.",
      "parcialAoMinuto": "Ata parcial: gravação interrompida ao 1 minuto. Parte da conversa não foi registrada.",
      "parcialMenosDeUmMinuto": "Ata parcial: gravação interrompida com menos de 1 minuto. Parte da conversa não foi registrada.",
      "confiancaBaixa": "Alguns trechos ficaram com áudio ruim e podem ter erro de transcrição.",
      "listaVazia": "Nada nesta lista.",
      "aprovarAta": "Aprovar ata",
      "aprovarItem": "Aprovar item",
      "efetivarItem": "Efetivar item",
      "dono": "Responsável: {{nome}}",
      "donoPorApelido": "Responsável: {{nome}} (resolvido por apelido)",
      "lista": {
        "decisoes": "Decisões",
        "tarefas": "Tarefas",
        "pendencias": "Pendências",
        "propostas": "Propostas"
      },
      "ataNaoSaiu": "A reunião foi salva, mas a ata não pôde ser gerada agora. A transcrição está guardada e dá para gerar de novo."
    },
    "impedimento": {
      "item_needs_attestation": "Falta atestar de memória o trecho que sustenta este item.",
      "item_has_no_evidence": "Este item não tem trecho da conversa que o sustente.",
      "item_evidence_stale": "O trecho que sustenta este item mudou depois da revisão.",
      "non_objection_needs_confirmation": "Falta confirmar que ninguém se opôs.",
      "item_not_in_review": "Este item não está em revisão."
    },
    "recusa": {
      "transcription_provider_unconfigured": "A transcrição não está configurada nesta conta. A reunião não pode ser gravada agora, avise o responsável.",
      "transcription_provider_unavailable": "O serviço de transcrição não respondeu. Tente de novo em alguns minutos.",
      "consent_not_recorded": "Não foi possível registrar o consentimento. Sem ele, o microfone não abre.",
      "notice_attestation_missing": "Diga quantas pessoas estão na sala antes de gravar.",
      "notice_text_unresolved": "O aviso de gravação desta conta está incompleto. Avise o responsável.",
      "retention_policy_missing": "Esta conta não tem prazo de guarda definido. A reunião não pode começar.",
      "meeting_wrong_state": "Esta reunião já foi encerrada.",
      "chunk_out_of_session": "A gravação foi interrompida no servidor. O que já foi falado está salvo, o resto não.",
      "meeting_duration_exceeded": "A reunião passou do tempo máximo e foi encerrada.",
      "transcription_session_closed": "A sessão de transcrição já estava fechada.",
      "item_not_in_review": "Este item não está em revisão.",
      "item_already_effectuated": "Este item já foi efetivado.",
      "item_needs_attestation": "Falta atestar de memória o trecho deste item.",
      "item_has_no_evidence": "Este item não tem trecho que o sustente.",
      "item_evidence_stale": "O trecho deste item mudou depois da revisão.",
      "non_objection_needs_confirmation": "Falta confirmar que ninguém se opôs.",
      "meeting_already_purged": "Esta reunião já foi apagada.",
      "segment_out_of_order": "Os trechos chegaram fora de ordem. A gravação ficou inconsistente.",
      "effectuation_target_mismatch": "Este destino não serve para este item.",
      "correction_span_outside_segment": "O trecho corrigido está fora do pedaço original.",
      "legal_basis_missing": "A base legal desta reunião não fecha. Avise o responsável.",
      "not_authorized": "Seu perfil não permite esta ação.",
      "reviewer_not_authorized": "Seu perfil não permite revisar esta reunião.",
      "meeting_restricted": "Esta reunião é restrita.",
      "erasure_not_authorized": "Só o organizador ou um administrador pode apagar esta reunião.",
      "meeting_not_found": "Reunião não encontrada nesta conta.",
      "item_not_found": "Item não encontrado nesta reunião.",
      "tenant_mismatch": "Este registro é de outra empresa cadastrada no sistema, não da sua. Confira se você entrou na conta certa antes de tentar de novo.",
      "processing_record_missing": "Não encontramos o registro desta gravação no sistema. Abra a reunião de novo pela lista; se continuar, avise o responsável com o número da reunião.",
      "memory_fact_not_found": "Essa informação já não existe. Foi esquecida ou nunca chegou a ser salva. Atualize a tela antes de tentar de novo.",
      "segment_not_found": "Este trecho da transcrição não foi encontrado. Pode já ter sido substituído. Atualize a tela e tente de novo.",
      "work_order_needs_registered_owner": "Esta ordem de serviço precisa de um responsável já cadastrado. Cadastre o responsável no equipamento antes de continuar.",
      "owner_not_in_tenant_registry": "O responsável indicado não está cadastrado nesta empresa. Cadastre a pessoa ou escolha outro responsável já cadastrado.",
      "processing_record_immutable": "Este registro já foi fechado e não aceita mais alteração. Se precisar corrigir algo, avise o responsável pela conformidade.",
      "glossary_term_conflict": "Este termo do glossário conflita com um já cadastrado. Ajuste o texto ou use o termo existente.",
      "partial_decision_already_taken": "A decisão sobre esta gravação interrompida já foi tomada. Abra a reunião pela lista para ver o que ficou decidido.",
      "redaction_span_invalid": "O trecho marcado para ocultar não é válido neste ponto da transcrição. Selecione o trecho de novo, sem passar do texto original.",
      "navegador_sem_gravacao": "Este navegador não grava áudio. Use o Chrome no celular ou no computador.",
      "microfone_negado": "O acesso ao microfone foi negado. Permita o acesso para gravar.",
      "consentimento_ausente": "Marque o aviso de gravação antes de começar.",
      "participantes_nao_declarados": "Diga quantas pessoas estão na sala antes de gravar.",
      "desconhecida": "A reunião recusou esta ação com um motivo que esta tela ainda não conhece ({{code}}). Avise o responsável.",
      "transcript_empty": "A gravação não captou fala suficiente para gerar a ata. Confira se o aparelho ficou perto de quem falava.",
      "extraction_model_unavailable": "O gerador de ata não está configurado nesta conta. A reunião está salva, avise o responsável.",
      "extraction_output_unparseable": "O gerador de ata devolveu um resultado que não deu para ler. A transcrição está guardada e dá para tentar de novo.",
      "extraction_unexpected_failure": "A ata não pôde ser gerada por uma falha no servidor. A reunião e a transcrição estão salvas, e dá para gerar a ata de novo. Se repetir, avise o responsável.",
      "no_anchored_item_survived": "Nenhum item da ata se sustentou no que foi falado. A transcrição está guardada.",
      "anchor_not_found_in_transcript": "A ata citou um trecho que não foi encontrado na transcrição.",
      "extracao_sem_motivo": "A ata não foi gerada e o motor não informou o motivo. A reunião está salva.",
      "falha_de_rede": "Não deu para falar com o servidor. Confira a internet do aparelho e tente de novo.",
      "sessao_expirada": "Sua sessão expirou. Entre de novo para gravar a reunião.",
      "sem_permissao": "Seu perfil não permite abrir reunião nesta conta. Peça ao responsável para liberar.",
      "muitas_tentativas": "Muitos pedidos em pouco tempo. Espere um minuto e tente de novo.",
      "ata_nao_carregou": "A ata foi gerada e está salva, mas não deu para carregá-la agora. Encerre e abra a conversa de novo, ou tente em instantes."
    },
    "espera": {
      "parou": "parou antes de encerrar, com {{minutos}} min gravados. Processar o que foi falado, ou descartar?",
      "processar": "Gerar a ata do que foi gravado",
      "descartar": "Descartar",
      "descartarAviso": "A gravação é apagada e não volta."
    }
  },
  "painelConfirmacao": {
    "enviando": "Confirmando…",
    "tentarDeNovo": "Tentar de novo",
    "semConversa": "Não foi possível enviar: esta conversa não está disponível. Recarregue a página e tente de novo.",
    "naoEnviou": "A confirmação não saiu do aplicativo. Nada foi gravado; confira a conexão e tente de novo."
  },
  "campoData": {
    "abrirCalendario": "Abrir calendário",
    "calendario": "Calendário",
    "mesAnterior": "Mês anterior",
    "mesSeguinte": "Mês seguinte",
    "diasDaSemana": "D,S,T,Q,Q,S,S",
    "placeholder": "dd/mm/aaaa"
  },
  "campoSelecao": {
    "selecionar": "Selecionar"
  },
  "research": {
    "notice": {
      "running": "Buscando plano do {{label}} · {{elapsed}} de até {{ceiling}}",
      "ready": "Plano do {{label}} chegou. Toque para ver.",
      "failed": "Não consegui o plano do {{label}}. O plano provisório continua valendo.",
      "ceilingMinutes": "{{count}}min",
      "openAria": "Abrir a conversa onde a busca começou"
    },
    "provisionalBadge": "Provisório, buscando manual do fabricante",
    "arrived": "O manual do fabricante chegou, atualizei o plano.",
    "compare": {
      "title": "O manual do fabricante chegou e o seu plano já estava salvo",
      "added_one": "{{count}} tarefa nova no manual",
      "added_other": "{{count}} tarefas novas no manual",
      "changed_one": "{{count}} tarefa com periodicidade diferente",
      "changed_other": "{{count}} tarefas com periodicidade diferente",
      "same_one": "{{count}} tarefa igual",
      "same_other": "{{count}} tarefas iguais",
      "apply": "Aplicar manual",
      "keep": "Manter o meu"
    }
  },
  "ferramentas": {
    "nome": {
      "create_equipment": "Cadastrei o equipamento",
      "create_location": "Cadastrei o local",
      "create_maint_plan": "Montei o plano de manutenção",
      "create_task_list": "Montei a lista de tarefas",
      "create_wo_operation": "Acrescentei uma operação à ordem",
      "create_work_order": "Abri uma ordem de serviço",
      "get_equipment": "Abri o cadastro do equipamento",
      "get_maint_plan": "Abri o plano de manutenção",
      "get_plant_list": "Listei as plantas",
      "get_work_order": "Abri a ordem de serviço",
      "list_materials": "Listei os materiais",
      "query_maintenance_metrics": "Consultei os indicadores de manutenção",
      "search_equipment": "Procurei equipamentos",
      "search_form": "Procurei formulários",
      "search_maint_plan": "Procurei planos de manutenção",
      "search_manufacturer": "Procurei fabricantes",
      "search_material": "Procurei materiais",
      "search_notification": "Procurei notificações",
      "search_team": "Procurei equipes"
    },
    "parametro": {
      "dims": "Recorte",
      "entity": "Cadastro",
      "filters": "Filtros",
      "from": "De",
      "limit": "Limite",
      "metrics": "Indicadores",
      "period": "Período",
      "query": "Busca",
      "status": "Situação",
      "to": "Até"
    },
    "valor": {
      "area": "Área",
      "availability": "Disponibilidade",
      "backlog_weeks": "Backlog (semanas)",
      "compliance": "Cumprimento do plano",
      "corrective": "Corretiva",
      "equipment": "Equipamento",
      "location": "Local",
      "month": "Mês",
      "mtbf": "MTBF",
      "mttr": "MTTR",
      "predictive": "Preditiva",
      "preventive": "Preventiva",
      "quarter": "Trimestre",
      "team": "Equipe",
      "week": "Semana"
    }
  },
  "schedule": {
    "review": {
      "historyUnavailable": "Não foi possível carregar as versões salvas.",
      "versions": "Versões salvas",
      "exportExcel": "Exportar versão Excel",
      "exportPdf": "Exportar versão PDF",
      "specialtyLoad": "Carga e capacidade por especialidade",
      "specialty": "Especialidade",
      "week": "Semana",
      "before": "Carga antes (h)",
      "after": "Carga depois (h)",
      "capacity": "Capacidade (h)",
      "unknownCapacity": "Não informada",
      "unknownSpecialty": "Especialidade não informada"
    },
    "unlinkedArea": "Sem área vinculada",
    "areaUnavailable": "Área indisponível",
    "areaMetadataError": "Não foi possível carregar as áreas. O cronograma continua disponível.",
    "areaContext": "Área: {{names}}",
    "readOnly": "Somente leitura: só administrador ou gestor pode mover ou editar o cronograma.",
    "warning": {
      "totalShutdown": "Semana em parada total: a tarefa foi gravada mesmo assim.",
      "totalShutdownWeek": "Semana {{week}} em parada total: a tarefa foi gravada mesmo assim."
    },
    "level": {
      "title": "Nivelar carga",
      "description": "Veja a proposta e seu impacto antes de aplicar. Nenhuma data muda ao gerar a proposta.",
      "impact": "Máximo semanal: {{before}} → {{after}} h. Desvio: {{beforeDeviation}} → {{afterDeviation}}.",
      "move": "{{plan}} · Semana {{from}} → {{to}} · {{hours}} h",
      "empty": "Nenhum movimento recomendado.",
      "propose": "Gerar proposta",
      "apply": "Aplicar proposta"
    },
    "reloadRetry": "A versão foi salva, mas a grade não carregou. Use Salvar para tentar carregar novamente.",
    "undoUnavailable": "Desfazer indisponível: o servidor não forneceu um registro de restauração válido.",
    "undoExpired": "Não foi possível desfazer: a programação mudou depois do movimento ou o registro de desfazer expirou. A grade foi recarregada.",
    "title": "Cronograma Anual {{weeks}} Semanas",
    "aiBadge": "{{count}} inferidos pela IA",
    "annualSummary": "{{equipment}} equipamentos · {{plans}} planos · {{orders}} OS no ano · {{hours}}h",
    "annualSummaryWithoutHours": "{{equipment}} equipamentos · {{plans}} planos · {{orders}} OS no ano · Horas não estimadas",
    "summary": "{{orders}} OS no ano · {{hours}}h",
    "currentWeek": "esta semana: {{orders}} ordens · {{hours}}h",
    "equipmentCount": "{{count}} equipamentos",
    "blocked": "Bloqueado",
    "shutdown": "Parada Coletiva",
    "today": "Hoje",
    "crit": {
      "label": "Criticidade",
      "a": "A",
      "b": "B",
      "c": "C"
    },
    "picker": {
      "simulateSelected": "Simular {{count}} equipamentos",
      "simulatePlant": "Simular toda a planta",
      "loading": "Carregando o cronograma de 52 semanas…",
      "loadError": "Não foi possível carregar o cronograma. Confira a conexão e tente novamente pelos controles abaixo.",
      "plant": "Planta",
      "choosePlant": "Selecione uma planta",
      "title": "Escolha os equipamentos",
      "hint": "Escolha um ou mais equipamentos para ver o cronograma do ano.",
      "criticalOnly": "Só críticos A",
      "wholePlant": "Toda a planta",
      "viewSelected": "Ver {{count}} equipamentos",
      "empty": "Nenhum equipamento cadastrado nesta planta."
    },
    "commands": {
      "cronograma": {
        "label": "Cronograma do ano",
        "description": "ano de 52 semanas"
      }
    },
    "actions": {
      "versions": "Versões salvas",
      "expand": "Abrir cronograma",
      "save": "Salvar",
      "compare": "Linha de Base",
      "compareDisabled": "Disponível na próxima fase",
      "excel": "Excel",
      "pdf": "PDF A3",
      "exportExcel": "Exportar Excel (.xlsx) formatado para PCM",
      "exportPdf": "Exportar PDF formatado A3 industrial",
      "saveVersion": "Gravar Simulação",
      "saveDisabled": "Disponível na próxima fase",
      "exportError": "Não foi possível exportar o cronograma.",
      "exportDisabled": "Nada a exportar: o filtro ativo esvazia a grade deste card."
    },
    "filters": {
      "all": "Todos ({{count}})",
      "criticalEquipment": "Críticos Grau A ({{count}})",
      "taskCriticalityA": "Tarefas A ({{count}})",
      "search": "Filtrar equipamento..."
    },
    "period": {
      "label": "Período do cronograma",
      "day": "Dia",
      "week": "Semana",
      "month": "Mês",
      "year": "Ano"
    },
    "status": {
      "hint": "Clique ou arraste uma ocorrência. Selecione semanas na régua para bloquear.",
      "capacity": "Capacidade da equipe: {{hours}}h",
      "scenario": "Cenário: {{name}} v{{version}}",
      "comparing": "Comparando com: {{label}}",
      "dragging": "Reagendando: {{label}} · Semana {{from}} → Semana {{to}} · Desvio vs Linha de Base: {{weeks}} Semanas ({{days}}d)",
      "loading": "Carregando cronograma…",
      "loadError": "Não foi possível carregar o cronograma: {{message}}",
      "undo": "Desfazer",
      "teamLoad": "Carga equipe: {{hours}}h/{{capacity}}h",
      "capacityUnknown": "Capacidade não informada",
      "capacityOver": "Acima da capacidade",
      "capacityIdeal": "Capacidade ideal"
    },
    "quarter": {
      "shutdown": "Parada Coletiva",
      "range": "Sem {{from}} - {{to}} · {{months}}",
      "assetHeader": "Ativo & Criticidade",
      "months": {
        "1": "Jan - Mar",
        "2": "Abr - Jun",
        "3": "Jul - Set",
        "4": "Out - Dez"
      }
    },
    "isoYearColumns": "Semanas de {{year}}",
    "task": {
      "summary": "{{duration}} · {{technician}}",
      "edit": "Editar tarefa",
      "addIntervention": "+ Intervenção"
    },
      "year": {
        "label": "Ano do cronograma",
        "single": "Só existe cenário simulado para {{year}}.",
        "loadError": "Não foi possível abrir o cenário desse ano."
      },
    "tabs": {
      "label": "Seções do cronograma",
      "schedule": "Cronograma",
      "plans": "Planos",
      "cost": "Orçamento e custos",
      "capacity": "Capacidade da equipe",
      "exclusions": "Avisos e exclusões",
      "versions": "Versões",
      "orders": "Ordens de serviço",
      "audit": "Auditoria"
    },
    "panels": {
      "plans": {
        "title": "Planos e tarefas",
        "empty": "Nenhum plano com tarefas neste filtro.",
        "col": {
          "equipment": "Equipamento",
          "plan": "Plano",
          "task": "Tarefa",
          "criticality": "Crit.",
          "duration": "Duração",
          "source": "Origem",
          "rationale": "Justificativa"
        },
        "inferred": "Inferido pela IA",
        "reviewed": "Revisado"
      },
      "orders": {
        "title": "Ordens de serviço",
        "empty": "Nenhuma ordem neste filtro.",
        "simulated": "Simulada",
        "truncated": "Mostrando {{shown}} de {{total}} ordens, em ordem de data. Use Excel para a lista completa.",
        "col": {
          "order": "Ordem",
          "equipment": "Equipamento",
          "plan": "Plano",
          "date": "Data",
          "week": "Semana",
          "status": "Situação",
          "hours": "Horas"
        },
        "status": {
          "done": "Concluída",
          "open": "Aberta",
          "planned": "Planejada",
          "overdue": "Atrasada"
        }
      },
      "exclusions": {
        "title": "Avisos e exclusões",
        "empty": "Nenhum aviso: todos os planos deste filtro estão na grade.",
        "week53": "2026 tem 53 semanas ISO: mostrar 53 colunas não é erro.",
        "inactive": "Planos inativos (fora da grade)",
        "notSchedulable": "Planos sem data fixa (por turno ou por condição)",
        "blocks": "Bloqueios de data e paradas",
        "omitted": "{{count}} equipamento(s) desativado(s) omitido(s) da grade.",
        "inactiveItem": "{{tag}} · {{plan}} está inativo e não aparece na grade.",
        "notSchedulableItem": "{{tag}} · {{plan}} não é programável por data: {{band}}.",
        "blockItem": "{{kind}} · semanas {{from}} a {{to}} · {{reason}}",
        "blockKind": {
          "date_block": "Bloqueio de data",
          "total_shutdown": "Parada coletiva"
        }
      },
      "capacity": {
        "title": "Capacidade da equipe",
        "empty": "Nenhuma semana com horas planejadas neste cenário.",
        "summary": "{{hours}}h planejadas · {{over}} semana(s) acima da capacidade.",
        "col": {
          "week": "Semana",
          "hours": "Planejado",
          "capacity": "Capacidade",
          "load": "Carga",
          "status": "Situação"
        },
        "alert": {
          "ok": "Dentro da capacidade",
          "over": "Acima da capacidade",
          "idle": "Ociosa"
        }
      },
      "cost": {
        "title": "Orçamento e custos",
        "empty": "Nenhum custo previsto neste cenário.",
        "summary": "Material previsto: {{material}} · mão de obra: {{hours}}h.",
        "noBudget": "Orçamento anual não informado: o cartão do cronograma não traz orçamento, só o previsto por semana.",
        "col": {
          "week": "Semana",
          "hours": "Mão de obra",
          "material": "Material"
        }
      },
      "loading": "Carregando…",
      "versions": {
        "title": "Versões salvas",
        "empty": "Nenhuma versão salva ainda. Use \"Gravar Simulação\" para guardar uma.",
        "current": "Em exibição",
        "col": {
          "version": "Versão",
          "name": "Nome",
          "date": "Salva em",
          "current": "Situação"
        }
      },
      "audit": {
        "title": "Auditoria do cenário",
        "empty": "Nenhum registro de auditoria para este cenário nos últimos 100 eventos do tenant.",
        "forbidden": "A auditoria só está disponível para administradores.",
        "failed": "Não foi possível carregar a auditoria agora.",
        "col": {
          "at": "Quando",
          "action": "Ação",
          "actor": "Quem"
        }
      }
    },
    "plan": {
      "tolerance": "Tolerância: −{{early}}% / +{{late}}%",
      "lineSymmetric": "{{cycle}} · {{hours}}h · ±{{tolerance}}%",
      "lineAsymmetric": "{{cycle}} · {{hours}}h · −{{early}}% / +{{late}}%",
      "summary": "{{cycle}} · {{hours}}h",
      "activate": "Ativar"
    },
    "procedure": {
      "title": "Procedimento",
      "empty": "Procedimento não cadastrado"
    },
    "lane": {
      "choosePlan": "Escolha o plano deste equipamento",
      "collapse": "Recolher",
      "expand": "Expandir",
      "summary": "{{plans}} planos · {{orders}} OS",
      "addIntervention": "+ Intervenção",
      "empty": "Nenhum equipamento neste filtro."
    },
    "legend": {
      "aiInferred": "IA · contorno tracejado indica dado inferido",
      "weekToday": "Semana atual",
      "weekBlocked": "Bloqueio de data",
      "weekShutdown": "Parada coletiva"
    },
    "occurrence": {
      "week": "S{{week}}",
      "weekBadge": "W{{week}}",
      "tooltip": "W{{week}} · {{status}}",
      "group_one": "{{count}} ocorrência · S{{week}} · {{states}}",
      "group_other": "{{count}} ocorrências · S{{week}} · {{states}}",
      "status": {
        "done": "Concluída",
        "open": "Aberta",
        "planned": "Planejada",
        "overdue": "Atrasada"
      }
    },
    "footer": {
      "dragActive": "Drag & Drop Ativo · Pressione ESC para soltar",
      "escape": "Esc para descartar o arraste",
      "escapeKey": "Esc",
      "dropHint": "Enter confirma · Esc descarta",
      "willWriteOrder": "Prévia: chamada do plano {{label}} → S{{week}} · OS {{code}} será reprogramada",
      "selection": "Seleção:",
      "technician": "Técnico Resp:",
      "impact": "Impacto Linha:",
      "noImpact": "Não informado",
      "discard": "Descartar",
      "confirm": "Confirmar Alteração",
      "writeDisabled": "Disponível na próxima fase",
      "willWrite": "Prévia: chamada do plano {{label}} → S{{week}} · será reprogramada",
      "noChange": "Sem alteração: {{label}} permanece na semana {{week}}.",
      "scopeOnly": "Só esta ocorrência",
      "scopeFollowing": "Esta e as seguintes",
      "reasonLabel": "Motivo",
      "reasonRequiredHint": "Diga o motivo (tarefa crítica fora da tolerância)",
      "operating": "Operação contínua",
      "partialStop": "Parada parcial",
      "fullStop": "Parada total do equipamento",
      "editTechnician": "Editar técnico responsável"
    },
    "dragError": {
      "invalidWeek": "Semana de destino inválida ou fora do horizonte do cronograma. Escolha outra semana.",
      "conflict": "A ocorrência mudou desde que esta tela foi carregada. Atualize o cronograma e tente de novo."
    },
    "inlineEdit": {
      "duration": "Tempo (min)",
      "technician": "Técnico",
      "team": "Equipe",
      "criticality": "Criticidade",
      "rationale": "Motivo",
      "rationalePlaceholder": "Por que essa criticidade?",
      "save": "Salvar",
      "cancel": "Cancelar",
      "none": "-",
      "inferredBadge": "Inferido pela IA"
    },
    "dateBlock": {
      "title": "Semanas {{from}} a {{to}}",
      "dateBlockKind": "Bloqueio de data",
      "totalShutdownKind": "Parada total",
      "confirm": "Confirmar bloqueio",
      "reasonPlaceholder": "Por que esta janela está bloqueada?",
      "multiplePlants": "Cronograma mostra mais de uma planta, filtre por uma planta para bloquear datas.",
      "noPlant": "Nenhum equipamento com planta neste cronograma."
    },
    "ack": {
      "title": "Valores preenchidos pela IA",
      "body": "Este planejamento tem {{count}} valores preenchidos pela IA ({{fields}}).",
      "warning": "A IA pode errar. Revise os itens marcados com a estrela de inferido antes de usar este cronograma para comprar material ou reservar equipe.",
      "review": "Revisar os {{count}} itens",
      "confirm": "Estou ciente e quero salvar"
    },
    "compare": {
      "orders": "Δ OS: {{delta}}",
      "hours": "Δ Horas: {{delta}}h",
      "cost": "Δ Custo: {{delta}}"
    },
    "intervention": {
      "visibilityUnverified": "A presença na grade ainda não foi verificada. Confira a janela e os filtros atuais.",
      "createdWithoutCode": "Intervenção criada. O número da ordem não está disponível.",
      "createdWithCode": "Intervenção criada: {{code}}.",
      "reloadRetry": "A intervenção foi criada, mas o cronograma não carregou. Tente atualizar novamente; outra intervenção não será criada.",
      "retry": "Atualizar cronograma",
      "description": "Descrição",
      "descriptionPlaceholder": "O que precisa ser feito?",
      "confirm": "Abrir intervenção"
    }
  },
  "platform": {
    "novaEmpresa": "Nova empresa",
    "criarEmpresa": "Criar e convidar",
    "criandoEmpresa": "Criando…",
    "ajudaEmailDoAdmin": "Esta pessoa recebe o convite por e-mail e entra como admin da empresa. Ela convida o resto da equipe.",
    "liberacoes": {
      "titulo": "Liberações",
      "subtitulo": "Funcionalidades novas liberadas neste ambiente. A chave vale para todas as empresas.",
      "ligada": "Ligada",
      "desligada": "Desligada",
      "ligadaDev": "Ligada (desenvolvimento)",
      "travadaDev": "Em desenvolvimento a chave fica sempre ligada e não se desliga.",
      "ambiente": "Ambiente",
      "dono": "Dono",
      "venceEm": "Vence em",
      "oQueMuda": "O que muda na tela",
      "carregando": "Carregando liberações…",
      "vazio": "Nenhuma chave de liberação.",
      "erro": "Não foi possível carregar ou alterar as liberações. Tente de novo.",
      "ligar": "Ligar {{nome}}",
      "desligar": "Desligar {{nome}}"
    },
    "aba": "Empresas",
    "titulo": "Empresas da plataforma",
    "subtitulo": "Todas as empresas cadastradas e as pessoas de cada uma.",
    "buscarEmpresa": "Buscar empresa",
    "buscarPessoa": "Buscar pessoa",
    "escolhaUmaEmpresa": "Escolha uma empresa na lista ao lado.",
    "plano": "Plano",
    "pessoasAtivas": "Pessoas ativas",
    "pessoasTotal": "Pessoas cadastradas",
    "pessoaAtiva": "Ativa",
    "pessoaInativa": "Inativa",
    "suspenderEmpresa": "Suspender empresa",
    "reativarEmpresa": "Reativar empresa",
    "novaPessoa": "Nova pessoa",
    "editarPessoa": "Editar pessoa",
    "editar": "Editar",
    "desativar": "Desativar",
    "reativar": "Reativar",
    "cancelar": "Cancelar",
    "salvar": "Salvar",
    "salvando": "Salvando...",
    "fechar": "Fechar",
    "emailNaoMuda": "O e-mail é a forma como a pessoa entra. Ele não muda por aqui.",
    "convitesPendentes": "{{count}} convite(s) criado(s) e ainda não aceito(s).",
    "situacao": {
      "active": "Ativa",
      "suspended": "Suspensa"
    },
    "campo": {
      "email": "E-mail",
      "nome": "Nome",
      "papel": "Papel",
      "nomeDaEmpresa": "Nome da empresa",
      "emailDoAdmin": "E-mail do admin da empresa"
    },
    "validacao": {
      "email": "Informe um e-mail válido.",
      "nome": "Informe o nome.",
      "nomeDaEmpresa": "Informe o nome da empresa."
    },
    "papel": {
      "admin": "Administrador",
      "manager": "Gestor",
      "technician": "Técnico",
      "viewer": "Consulta"
    },
    "coluna": {
      "nome": "Nome",
      "email": "E-mail",
      "papel": "Papel",
      "situacao": "Situação",
      "acoes": "Ações"
    },
    "confirmarSuspender": {
      "titulo": "Suspender esta empresa?",
      "mensagem": "As pessoas de {{nome}} perdem o acesso enquanto a empresa estiver suspensa. Nada é apagado, e você pode reativar a qualquer momento."
    },
    "confirmarDesativar": {
      "titulo": "Desativar esta pessoa?",
      "mensagem": "{{nome}} perde o acesso e continua na lista, marcada como inativa. Você pode reativar a qualquer momento."
    },
    "erro": {
      "USER_EXISTS": "Já existe uma pessoa com este e-mail nesta empresa.",
      "USER_EXISTS_OTHER_TENANT": "Este e-mail já pertence a outra empresa.",
      "CANNOT_DEACTIVATE_SELF": "Você não pode desativar a si mesmo.",
      "INVITE_FAILED": "O convite não pôde ser enviado. Nada foi criado; tente de novo.",
      "ROLE_NOT_PROVISIONED": "Esta empresa ainda não tem esse papel configurado.",
      "TENANT_NOT_FOUND": "Empresa não encontrada.",
      "USER_NOT_FOUND": "Pessoa não encontrada nesta empresa.",
      "FORBIDDEN_PLATFORM_ADMIN": "Você não tem acesso a esta área.",
      "NETWORK": "Sem resposta do servidor. Confira a conexão e tente de novo.",
      "DESCONHECIDO": "Não deu para concluir. Tente de novo; se repetir, avise o suporte.",
      "INVITE_ALREADY_PENDING": "Esta pessoa já foi convidada e ainda não aceitou.",
      "TENANT_SLUG_TAKEN": "Já existe uma empresa com esse nome.",
      "CATALOG_NOT_SEEDED": "Esta base ainda não tem o plano ou o papel de admin cadastrado."
    }
  },
  "planComparison": {
    "title": "Comparação do plano",
    "equipment": "Equipamento: {{manufacturer}} {{model}}",
    "summaryLabel": "Resumo da comparação",
    "client": "Seu plano",
    "reference": "Referência",
    "absent": "Não consta",
    "every": "A cada {{value}} {{unit}}",
    "noInterval": "Sem intervalo informado",
    "row": "Linha {{number}} da planilha: {{text}}",
    "source": "Fonte: {{host}}",
    "unverified": "Fonte não conferida",
    "notCompared": "Unidades diferentes: não comparado numericamente.",
    "assumir": "Assumir como plano oficial",
    "useEquipment": "Usar {{manufacturer}} {{model}}",
    "status": {
      "igual": "Igual",
      "intervalo_diferente": "Intervalo diferente",
      "falta_no_cliente": "Falta no seu plano",
      "so_no_cliente": "Só no seu plano",
      "nao_comparavel": "Não comparável"
    },
    "adopt": {
      "intervalo_diferente": "Usar o intervalo da referência",
      "falta_no_cliente": "Adicionar ao meu plano"
    },
    "unit": {
      "HOURS_one": "hora",
      "HOURS_other": "horas",
      "DAYS_one": "dia",
      "DAYS_other": "dias",
      "WEEKS_one": "semana",
      "WEEKS_other": "semanas",
      "MONTHS_one": "mês",
      "MONTHS_other": "meses",
      "YEARS_one": "ano",
      "YEARS_other": "anos",
      "CYCLES_one": "ciclo",
      "CYCLES_other": "ciclos"
    },
    "band": {
      "por_turno": "Por turno",
      "diaria": "Diária",
      "semanal": "Semanal",
      "mensal": "Mensal",
      "trimestral": "Trimestral",
      "semestral": "Semestral",
      "anual": "Anual",
      "por_hora_operacao": "Por hora de operação",
      "por_condicao": "Por condição"
    }
  },
  "guardian": {
    "commands": {
      "label": "Criar agente",
      "sub": {
        "novo": "Descrever um agente novo",
        "listar": "Ver seus agentes no painel",
        "rodar": "Preparar um plano agora",
        "pausar": "Parar as próximas execuções",
        "editar": "Ajustar a regra do agente",
        "retomar": "Voltar a rodar um agente pausado"
      },
      "loadAgents": "Carregar seus agentes"
    },
    "create": "Criar agente",
    "missing": "Ainda não definido",
    "inferred": "Inferência: ver motivo",
    "specificApproval": "Sua aprovação vale somente para este plano e estes efeitos.",
    "expires": "Aprovação disponível até {{date}}",
    "results": "{{count}} resultados",
    "empty": "Nenhum agente nesta conversa.",
    "recommended": "Recomendado",
    "readOnly": "Somente leitura",
    "sendAnswer": "Enviar resposta",
    "deliveryFailed": "Não foi possível enviar esta ação. Consulte o estado atual na conversa antes de continuar.",
    "fields": {
      "where": "Onde",
      "object": "Objeto",
      "action": "Ação",
      "when": "Quando",
      "exceptions": "Exceções"
    },
    "state": {
      "DRAFT": "Rascunho",
      "ENTRY_REVIEW": "Analisando definição",
      "CLARIFYING": "Falta uma definição",
      "CONFIRMING": "Confirmação pendente",
      "BLIND_CHECK": "Conferindo significado",
      "CAPABILITY_CHECK": "Conferindo capacidade",
      "DRY_RUNNING": "Simulação em andamento",
      "EVIDENCE_BLOCKED": "Evidência insuficiente",
      "READY": "Pronto para ativar",
      "ACTIVE": "Ativo · propõe e pede aprovação",
      "PLAN_REVIEW": "Plano em revisão",
      "AWAITING_APPROVAL": "Aguardando aprovação",
      "EXECUTING": "Executando plano aprovado",
      "RECONCILING": "Conferindo resultado",
      "RECEIPT": "Resultado verificado",
      "PAUSED": "Pausado",
      "BLOCKED": "Bloqueado"
    },
    "card": {
      "agentPolicy": "Política do agente",
      "agentApproval": "Aprovar plano específico",
      "agentReceipt": "Resultado da execução",
      "agentExplanation": "Explicação e auditoria",
      "agentPanel": "Agentes de manutenção",
      "agentRun": "Execução do agente",
      "agentBreaker": "Disjuntor do agente",
      "agentTemplates": "Modelos prontos"
    },
    "approval": {
      "reviewing": "Em revisão",
      "blocked": "Bloqueado",
      "awaiting_approval": "Aguardando aprovação",
      "approved": "Aprovado",
      "rejected": "Rejeitado",
      "expired": "Expirado"
    },
    "outcome": {
      "succeeded": "Comprovado",
      "partial": "Parcial",
      "failed": "Falhou",
      "unverified": "Resultado não comprovado",
      "none": "Sem execução",
      "awaiting_approval": "Aguardando aprovação"
    },
    "dryRun": {
      "not_started": "Não iniciada",
      "running": "Em andamento",
      "sufficient": "Evidência suficiente",
      "insufficient": "Evidência insuficiente",
      "failed": "Falhou"
    },
    "method": {
      "historical_replay": "Replay de histórico real",
      "synthetic_history_replay": "Replay de histórico sintético",
      "current_snapshot": "Prévia do estado atual"
    },
    "review": {
      "approve": "Aprovou",
      "reject": "Rejeitou",
      "unavailable": "Indisponível"
    },
    "confirmation": {
      "pending": "Pendente",
      "confirmed": "Confirmada"
    },
    "mode": {
      "manual": "Manual",
      "scheduled": "Agendado"
    },
    "nextRun": "Próxima execução: {{date}}",
    "lastOutcome": "Último resultado",
    "effectPending": "A execução tem pendências. Consulte os motivos e a auditoria.",
    "samples": "{{count}} registros examinados",
    "d6": {
      "pending": "Entendimento em revisão",
      "blocked": "Entendimento bloqueado",
      "green": "Entendimento conferido"
    },
    "boolean": {
      "true": "Sim",
      "false": "Não"
    },
    "noValue": "Sem valor",
    "recordedDecision": "Decisão de admissibilidade registrada",
    "admissibility": {
      "pending": "Admissibilidade pendente",
      "accepted": "Admissibilidade aceita",
      "rejected": "Admissibilidade recusada"
    },
    "rejectionReason": "Motivo da recusa",
    "confirmRejection": "Rejeitar este plano",
    "checkState": "Consultar estado dos agentes",
    "run": {
      "meta": "versão {{version}} · {{trigger}} · {{date}}",
      "trace": "rastro {{trace}}",
      "receipt": "Recibo {{label}}",
      "created": "novo",
      "showAll": "Ver as {{count}} ações",
      "step": {
        "pending": "pendente",
        "pending_verification": "aguardando conferência",
        "uncertain": "resultado incerto",
        "blocked": "bloqueado",
        "failed": "falhou"
      },
      "status": {
        "running": "Em execução",
        "completed": "Concluída",
        "nothing_to_do": "Nada a fazer",
        "awaiting_approval": "Aguardando aprovação",
        "rejected_by_guardian": "Reprovada pelo Guardian",
        "rejected_by_human": "Recusada por você",
        "breaker_tripped": "Parada pelo disjuntor",
        "partial": "Parcial",
        "receipt_failed": "Recibo não conferido",
        "uncertain": "Resultado incerto",
        "failed": "Falhou"
      }
    },
    "breaker": {
      "per_run": "Teto por execução",
      "per_day": "Teto do dia",
      "per_tenant_day": "Teto do dia da empresa",
      "repeated_pattern": "Padrão repetido",
      "out_of_scope": "Fora do escopo"
    },
    "rewrite": "Reescrever a regra",
    "activate": "Ativar",
    "question": {
      "confirm": "Confirmar",
      "writeOther": "Escrever outra resposta"
    },
    "panel": {
      "title": "Seus agentes",
      "count_one": "{{count}} ativo de {{total}}",
      "count_other": "{{count}} ativos de {{total}}",
      "close": "Fechar painel de agentes",
      "open": "Abrir painel de agentes",
      "loading": "Carregando seus agentes…",
      "empty": "Nenhum agente ainda. Descreva no chat o que um agente deve fazer.",
      "more": "Ver mais agentes",
      "pointer_one": "{{count}} agente no painel à direita",
      "pointer_other": "{{count}} agentes no painel à direita",
      "version": "versão {{version}}",
      "approvedBy": "aprovada por {{name}} em {{date}}",
      "runs": "Roda",
      "next": "Próxima",
      "lastRun": "Última execução",
      "never": "nunca"
    },
    "seal": {
      "explicit": "No texto",
      "assumed": "Suposto",
      "confirmed": "Confirmado",
      "missing": "Falta definir"
    },
    "understood": {
      "label": "Entendi assim",
      "newVersion": "Nova versão do agente (base: versão {{version}})",
      "youWrote": "Você escreveu:",
      "tools": "Ferramentas do AxiomGO que o agente vai usar",
      "limits": "até {{perRun}} ações por execução e {{perDay}} por dia"
    },
    "toolKind": {
      "read": "Só lê",
      "write": "Altera dados"
    },
    "autonomy": {
      "propose_and_ask": "Propõe e pede sua aprovação antes de agir",
      "act_within_limits": "Age dentro dos limites"
    },
    "rehearsal": {
      "history": "Ensaio no histórico real",
      "snapshot": "Prévia do estado atual (não libera a ativação)",
      "result": "Teria mexido em {{affected}} de {{total}}",
      "examples": "ex.: {{examples}}",
      "status": "Ensaio: {{status}}"
    },
    "highRisk": "Alto risco: dois juízes de famílias diferentes"
  },
  "horizonGeneration": {
    "title": "Processamento das ordens de serviço",
    "period": "Período solicitado: {{from}} a {{to}} ({{months}} meses)",
    "loading": "Consultando o processamento…",
    "waiting": "Aguardando processamento",
    "processing": "Processando ordens de serviço",
    "completed": "Processamento concluído",
    "partially_completed": "Processamento parcialmente concluído",
    "failed": "O processamento falhou",
    "unavailable": "Resultado ainda não verificável",
    "progress": "Planos processados: {{finishedPlans}} de {{totalPlans}}",
    "totals": "Ocorrências nesta execução: {{generated}} geradas, {{reused}} reutilizadas, {{skipped}} ignoradas e {{failed}} falhas.",
    "reconciliation": "{{generatedDistinct}} OS distintas vinculadas às ocorrências geradas; {{groupedOccurrences}} ocorrências adicionais agrupadas nessas OS.",
    "reconciliationUnknown": "Este recibo não permite confirmar a quantidade de OS distintas vinculadas às ocorrências geradas.",
    "orders_one": "{{count}} OS encontrada no período solicitado.",
    "orders_other": "{{count}} OS encontradas no período solicitado.",
    "failure": "Confira as ordens já existentes e atualize a consulta antes de tentar gerar novamente.",
    "readError": "Não foi possível atualizar a consulta. O último resultado verificado, quando disponível, foi preservado.",
    "paused": "A atualização automática foi pausada. Consulte novamente para verificar o estado atual.",
    "refresh": "Atualizar processamento",
    "showOrders": "Ver ordens de serviço",
    "hideOrders": "Ocultar ordens de serviço",
    "previous": "Anterior",
    "next": "Próxima",
    "orders_zero": "{{count}} OS encontradas no período solicitado."
  },
  "axisCopy": {
    "transicao_apos_tag_base_pronta": [
      "Pronto, {{tag}} registrada e sua base está pronta. Agora você decide: quer abrir uma ordem corretiva ou montar o plano preventivo?",
      "Show, base pronta com a {{tag}} salva. O que você quer fazer agora: abrir uma corretiva ou montar um plano preventivo?",
      "Beleza, {{tag}} anotada e a base fechada. Qual o próximo passo: uma ordem corretiva ou o plano preventivo?",
      "Perfeito, com a {{tag}} sua base está completa. Me diga: corretiva agora ou preventivo?",
      "Feito, {{tag}} registrada com sucesso. Sua base está pronta: quer abrir uma corretiva ou já montar o preventivo?",
      "Anotei a {{tag}}. Base fechada. Agora é com você: corretiva ou preventivo?",
      "Registrei a {{tag}}. Sua base está pronta pra uso: prefere abrir uma ordem corretiva ou montar o plano preventivo primeiro?",
      "Certo, {{tag}} salva e base pronta. O que fazemos agora: corretiva ou preventivo?",
      "Combinado, {{tag}} no sistema. Base fechada com sucesso: você quer abrir uma corretiva ou montar o preventivo?",
      "Fechado, {{tag}} registrada. Sua base está pronta: qual caminho você prefere, corretiva ou preventivo?",
      "{{tag}} salva com sucesso. Base pronta. Agora escolha: abrir uma ordem corretiva ou montar o plano preventivo.",
      "A {{tag}} foi registrada. Sua base está completa: quer partir pra uma corretiva ou montar o preventivo?",
      "Cadastrei a {{tag}}. Base pronta pra uso. O que você prefere agora: corretiva ou preventivo?",
      "{{tag}} anotada, show. Base fechada com sucesso. Corretiva ou preventivo, qual você quer agora?",
      "Salvei a {{tag}}. Sua base está pronta: vamos pra uma ordem corretiva ou preferimos montar o preventivo primeiro?",
      "{{tag}} registrada certinho. Base completa. Me diga o próximo passo: corretiva ou preventivo?",
      "Concluí o registro da {{tag}}. Base pronta. Você decide agora: abrir uma corretiva ou montar o plano preventivo.",
      "{{tag}} no sistema, base fechada. Qual o próximo movimento: corretiva ou preventivo?",
      "Registrei sua {{tag}} com sucesso. A base está pronta: prefere abrir uma corretiva ou montar o preventivo?",
      "{{tag}} salva, tudo certo. Base pronta pra uso. Corretiva ou preventivo, o que você escolhe?",
      "Terminei de salvar a {{tag}}. Sua base está completa agora. O que fazemos: corretiva ou preventivo?",
      "{{tag}} cadastrada com sucesso. Base pronta. Agora é com você: abrir uma ordem corretiva ou montar o preventivo?",
      "A {{tag}} está registrada. Base fechada, tudo certo. Qual caminho você quer seguir: corretiva ou preventivo?",
      "Cadastro da {{tag}} concluído. Sua base está pronta pra uso: corretiva ou preventivo primeiro?",
      "{{tag}} salva certinho. Base completa. Me diga: você quer abrir uma corretiva ou montar o plano preventivo agora?",
      "Registrei a {{tag}}, valeu. Base pronta. O que você prefere fazer agora: corretiva ou preventivo?",
      "{{tag}} anotada com sucesso. Sua base está fechada. Vamos pra uma ordem corretiva ou pro plano preventivo?",
      "Salvei sua {{tag}}. Base pronta pra uso agora. Qual o próximo passo: corretiva ou preventivo?",
      "{{tag}} registrada, base pronta. E agora, você quer abrir uma corretiva ou montar o preventivo?",
      "Concluído o cadastro da {{tag}}. Sua base está pronta: corretiva ou preventivo, qual você escolhe?",
      "{{tag}} salva no sistema. Base completa e pronta pra uso. O que fazemos agora: corretiva ou preventivo?",
      "Registrei {{tag}} certinho. Base fechada com sucesso. Me diga o próximo passo: corretiva ou preventivo?",
      "{{tag}} cadastrada, show de bola. Sua base está pronta. Qual caminho: corretiva ou preventivo?",
      "Salvei {{tag}} com sucesso. Base pronta pra uso. Agora é decisão sua: corretiva ou preventivo?",
      "A {{tag}} foi registrada certinho. Base completa. O que você prefere: abrir uma ordem corretiva ou montar o plano preventivo?",
      "{{tag}} anotada, base fechada. Vamos seguir com uma corretiva ou montar o preventivo primeiro?",
      "Cadastrei sua {{tag}}. Base pronta agora. Qual o próximo passo: corretiva ou preventivo?",
      "{{tag}} salva, tudo certo por aqui. Sua base está pronta: corretiva ou preventivo, o que você quer?",
      "Terminei o cadastro da {{tag}}. Base completa e pronta. Me diga: corretiva ou preventivo?",
      "{{tag}} registrada com sucesso, perfeito. Sua base está pronta pra uso. O que fazemos agora: corretiva ou preventivo?",
      "Salvei a {{tag}} certinho. Base fechada. Você decide: abrir uma corretiva ou montar o preventivo?",
      "{{tag}} no sistema, base pronta. Qual caminho você prefere seguir agora: corretiva ou preventivo?",
      "Cadastro da {{tag}} feito. Sua base está completa. Corretiva ou preventivo, qual vem primeiro?",
      "{{tag}} salva com sucesso, combinado. Base pronta pra uso. O que você quer fazer: corretiva ou preventivo?",
      "Registrei {{tag}} com sucesso. Sua base está fechada e pronta. Me diga o próximo passo: corretiva ou preventivo?",
      "{{tag}} cadastrada certinho. Base completa agora. Vamos pra uma ordem corretiva ou montar o plano preventivo?",
      "Salvei sua {{tag}} com sucesso. Base pronta. Qual você prefere agora: corretiva ou preventivo?",
      "{{tag}} registrada, tudo certo. Sua base está pronta pra uso: corretiva ou preventivo, o que escolhe?",
      "Concluí a {{tag}} no sistema. Base fechada com sucesso. O que fazemos agora: corretiva ou preventivo?",
      "{{tag}} salva, base pronta. Agora a decisão é sua: abrir uma corretiva ou montar o preventivo.",
      "Registrei a {{tag}} direitinho. Sua base está completa. Qual caminho você quer: corretiva ou preventivo?",
      "{{tag}} cadastrada com sucesso, show. Base pronta pra uso agora. Me diga: corretiva ou preventivo?",
      "Salvei {{tag}} certinho. Base fechada. O que você prefere fazer agora: corretiva ou preventivo?",
      "{{tag}} registrada, base pronta pra valer. Corretiva ou preventivo, qual você quer seguir primeiro?",
      "Cadastro de {{tag}} concluído com sucesso. Sua base está completa. Qual o próximo passo: corretiva ou preventivo?",
      "{{tag}} salva no sistema, perfeito. Base pronta. Agora é com você: corretiva ou preventivo?",
      "Registrei {{tag}}, valeu. Sua base está fechada e pronta pra uso. O que fazemos: corretiva ou preventivo?",
      "{{tag}} anotada certinho. Base completa agora. Vamos pra corretiva ou montar o preventivo primeiro?",
      "Salvei a {{tag}} com sucesso, combinado. Sua base está pronta. Qual você escolhe: corretiva ou preventivo?",
      "{{tag}} cadastrada, base fechada. Me diga o próximo passo agora: corretiva ou preventivo?",
      "Concluído o registro da {{tag}}. Sua base está pronta pra uso. O que você prefere: corretiva ou preventivo?",
      "{{tag}} salva certinho, show de bola. Base completa. Corretiva ou preventivo, qual vem primeiro?",
      "Registrei sua {{tag}} certinho. Base pronta agora. Qual caminho você quer seguir: corretiva ou preventivo?",
      "{{tag}} no sistema, tudo certo. Sua base está fechada e pronta. O que fazemos: corretiva ou preventivo?",
      "Salvei {{tag}} com sucesso, perfeito. Base pronta pra uso. Agora a decisão é sua: corretiva ou preventivo?",
      "{{tag}} registrada com sucesso. Base completa. Me diga: você quer abrir uma corretiva ou montar o preventivo?",
      "Cadastrei {{tag}} certinho. Sua base está pronta. Qual o próximo passo agora: corretiva ou preventivo?",
      "{{tag}} salva, base fechada com sucesso. O que você prefere fazer: corretiva ou preventivo?",
      "Registrei a {{tag}} com sucesso, valeu. Sua base está completa e pronta. Corretiva ou preventivo, qual escolhe?",
      "{{tag}} cadastrada certinho, combinado. Base pronta pra uso agora. Qual caminho você quer: corretiva ou preventivo?",
      "Salvei sua {{tag}} certinho. Base fechada e pronta. Me diga o próximo passo: corretiva ou preventivo?",
      "{{tag}} registrada, tudo certo por aqui. Sua base está completa. O que fazemos agora: corretiva ou preventivo?",
      "Concluí o cadastro da {{tag}}. Base pronta pra uso. Você decide: abrir uma corretiva ou montar o preventivo?",
      "{{tag}} salva com sucesso, show. Sua base está fechada. Qual você prefere: corretiva ou preventivo?",
      "Registrei {{tag}} certinho, perfeito. Base completa e pronta. O que você quer fazer agora: corretiva ou preventivo?",
      "{{tag}} anotada, base pronta. Corretiva ou preventivo, qual vem primeiro pra você?",
      "Salvei a {{tag}} com sucesso. Sua base está completa. Me diga o próximo passo: corretiva ou preventivo?",
      "{{tag}} cadastrada, tudo certo. Base pronta pra uso agora. Qual caminho você prefere: corretiva ou preventivo?",
      "Registrei sua {{tag}}, valeu. Base fechada com sucesso. O que fazemos agora: corretiva ou preventivo?",
      "{{tag}} salva certinho, combinado. Sua base está pronta. Qual você escolhe agora: corretiva ou preventivo?",
      "Cadastro da {{tag}} feito com sucesso. Base completa. Agora é com você: corretiva ou preventivo?",
      "{{tag}} registrada, base pronta pra valer. O que você prefere fazer: corretiva ou preventivo?",
      "Salvei {{tag}} certinho, show de bola. Sua base está fechada e pronta. Qual caminho: corretiva ou preventivo?",
      "{{tag}} no sistema com sucesso. Base completa agora. Me diga o próximo passo: corretiva ou preventivo?",
      "Registrei a {{tag}} certinho, perfeito. Sua base está pronta pra uso. Corretiva ou preventivo, qual escolhe?",
      "{{tag}} salva, base fechada. Agora a decisão é sua: abrir uma corretiva ou montar o preventivo.",
      "Concluído o registro da {{tag}}, valeu. Sua base está completa. O que fazemos agora: corretiva ou preventivo?",
      "{{tag}} cadastrada com sucesso, tudo certo. Base pronta. Qual você prefere: corretiva ou preventivo?",
      "Salvei sua {{tag}} com sucesso. Base fechada e pronta pra uso. Me diga: corretiva ou preventivo?",
      "{{tag}} registrada certinho, combinado. Sua base está completa agora. Qual caminho você quer seguir: corretiva ou preventivo?",
      "Registrei {{tag}}, show. Base pronta pra valer. O que você prefere fazer agora: corretiva ou preventivo?",
      "{{tag}} salva com sucesso, perfeito. Sua base está fechada. Corretiva ou preventivo, qual vem primeiro?",
      "Cadastrei a {{tag}} certinho. Base completa e pronta. Agora é com você: corretiva ou preventivo?",
      "{{tag}} anotada com sucesso, valeu. Sua base está pronta pra uso. Qual você escolhe: corretiva ou preventivo?",
      "Salvei {{tag}}, base fechada certinho. Me diga o próximo passo agora: corretiva ou preventivo?",
      "{{tag}} registrada, tudo certo por aqui. Sua base está completa e pronta. O que fazemos: corretiva ou preventivo?",
      "Concluí a {{tag}} com sucesso. Base pronta pra uso agora. Qual caminho você prefere: corretiva ou preventivo?",
      "{{tag}} salva certinho, combinado. Sua base está fechada. Agora a decisão é sua: corretiva ou preventivo?",
      "Registrei sua {{tag}} com sucesso, show de bola. Base completa. O que você quer fazer agora: corretiva ou preventivo?",
      "{{tag}} cadastrada, base pronta pra valer. Última decisão antes de seguir: corretiva ou preventivo, qual você escolhe?"
    ],
    "transicao_apos_planta": [
      "Certo, planta {{planta}}. E em qual localização, dentro dela? Isso mantém as ordens organizadas por setor.",
      "Planta {{planta}}, entendido. Agora a localização: área ou linha onde o equipamento fica.",
      "Combinado, {{planta}}. Me diga a localização dentro dela, área ou linha.",
      "{{planta}}, certo. Qual localização dentro da planta? Área, linha ou setor.",
      "Fechado, {{planta}}. Falta a localização: onde exatamente dentro da planta?",
      "Ok, planta {{planta}}. Em qual área ou linha o equipamento fica?",
      "Entendi, {{planta}}. Agora preciso da localização dentro dela para as ordens saírem por setor.",
      "Beleza, {{planta}}. Qual é a localização, a área ou a linha onde ele opera?",
      "Vamos com {{planta}}. Me diga a localização dentro da planta e seguimos.",
      "Show, {{planta}}. Qual localização dentro dela?",
      "Planta {{planta}} então. A próxima informação é a localização, área ou linha.",
      "Perfeito, {{planta}}. Onde dentro da planta ele fica? Área ou linha."
    ],
    "transicao_apos_localizacao": [
      "Certo, localização {{localizacao}}. Agora a tag, o código que identifica esse equipamento na sua planta.",
      "{{localizacao}}, entendido. Falta a tag: o código único dele. Posso gerar uma se preferir.",
      "Combinado, {{localizacao}}. Como você quer identificar esse equipamento? A tag é o código dele.",
      "Fechado, {{localizacao}}. Me diga a tag, o código de identificação, ou peça uma automática.",
      "Ok, {{localizacao}}. Agora a tag, o código que identifica o equipamento.",
      "Entendi, {{localizacao}}. Agora a tag dele, o código único na planta.",
      "Beleza, {{localizacao}}. Qual tag você quer usar? Também consigo gerar uma.",
      "Vamos com {{localizacao}}. Falta a tag, o código de identificação.",
      "Show, {{localizacao}}. Me diga a tag do equipamento, o código dele.",
      "{{localizacao}}, certo. A próxima informação é a tag.",
      "Perfeito, {{localizacao}}. Como identificar esse equipamento? Preciso da tag.",
      "Localização {{localizacao}} então. Agora a tag, que identifica ele de forma única aqui."
    ]
  },
  "equipmentHistory": {
    "closureNote": "Relato de encerramento",
    "unavailable": "Não foi possível apresentar o histórico recebido. Reabra a consulta para tentar novamente.",
    "equipment": "Equipamento",
    "actions": "Ações",
    "planEquipment": "Plano / equipamento",
    "title": "Histórico de {{tag}}",
    "summary": "{{totalWorkOrders}} OS e {{totalNotifications}} notificações neste recorte; {{activeMaintPlans}} planos ativos na consulta.",
    "scope": "Fonte: histórico do equipamento. Eventos limitados a {{limit}} registros por tipo; as datas preservam o fuso da fonte.",
    "returned": "{{count}} registros recebidos",
    "empty": "Nenhum registro neste recorte.",
    "previous": "Anterior",
    "next": "Próxima",
    "page": "Página {{page}} de {{pages}}",
    "events": "Eventos",
    "plans": "Planos preventivos",
    "date": "Data e hora (fonte)",
    "reference": "Referência",
    "priority": "Prioridade",
    "status": "Status",
    "description": "Descrição",
    "frequency": "Frequência / unidade",
    "last": "Última execução",
    "nextDue": "Próxima execução",
    "active": "Ativo",
    "inactive": "Inativo",
    "units": {"days": "dias", "weeks": "semanas", "months": "meses", "hours": "horas", "cycles": "ciclos", "km": "km", "DAYS": "dias", "WEEKS": "semanas", "MONTHS": "meses", "HOURS": "horas", "CYCLES": "ciclos"}
  },
  "readOnlyList": {
    "unavailable": "Não foi possível apresentar esta listagem. Reabra a consulta para tentar novamente.",
    "yes": "Sim",
    "no": "Não",
    "received": "{{count}} registros recebidos",
    "count": "{{count}} registros recebidos de {{total}} no escopo consultado",
    "empty": "Nenhum registro neste recorte.",
    "more": "Existem outros registros fora deste recorte.",
    "unknownScope": "A fonte não informou se existem outros registros além deste recorte.",
    "sources": {
      "search_location": "Localizações",
      "search_plant": "Plantas",
      "search_supplier": "Fornecedores",
      "search_specialty": "Especialidades",
      "search_task_list": "Listas de tarefas",
      "search_plan_calls": "Chamadas do plano",
      "search_failure_mode": "Modos de falha",
      "search_catalog": "Catálogo técnico",
      "list_team_members": "Membros da equipe",
      "list_team_technicians": "Técnicos da equipe",
      "list_in_app_alerts": "Alertas",
      "list_import_catalog": "Modelos de importação",
      "list_ltp_scenarios": "Cenários de planejamento",
      "get_proposals": "Propostas",
      "get_stock_overview": "Estoque por planta",
      "query_materials_by_pattern": "Materiais por padrão",
      "get_record_history": "Histórico do registro",
      "search_work_order": "Ordens de serviço",
      "search_technician": "Técnicos",
      "search_maint_plan": "Planos de manutenção"
    },
    "columns": {
      "code": "Código",
      "name": "Nome",
      "description": "Descrição",
      "plant": "Planta",
      "parent": "Localização pai",
      "category": "Categoria",
      "active": "Ativo",
      "specialty": "Especialidade",
      "operations": "Operações",
      "components": "Componentes",
      "reference": "Referência",
      "dueDate": "Vencimento",
      "plannedDate": "Data planejada",
      "shiftFollowing": "Desloca seguintes",
      "status": "Status",
      "movedAt": "Remarcado em",
      "moveReason": "Motivo",
      "causes": "Causas",
      "manufacturer": "Fabricante",
      "model": "Modelo",
      "confidence": "Confiança",
      "lastResearched": "Última pesquisa",
      "role": "Papel",
      "membership": "Vínculo",
      "primary": "Primário",
      "additional": "Adicional",
      "type": "Tipo",
      "priority": "Prioridade",
      "title": "Título",
      "body": "Relato",
      "createdAt": "Criado em",
      "read": "Lido",
      "requiredFields": "Campos obrigatórios",
      "optionalFields": "Campos opcionais",
      "anchorDate": "Início",
      "horizonWeeks": "Horizonte em semanas",
      "baselineYear": "Ano base",
      "createdBy": "Autor",
      "equipment": "Equipamento",
      "currentStock": "Saldo",
      "reservedStock": "Reservado",
      "available": "Disponível",
      "unit": "Unidade",
      "when": "Data e hora",
      "who": "Responsável",
      "action": "Ação",
      "detail": "Detalhe",
      "unreadCount": "Não lidos",
      "unreadCriticalCount": "Críticos não lidos",
      "unreadBeyondPage": "Não lidos fora do recorte",
      "page": "Página",
      "pageSize": "Tamanho da página",
      "limit": "Limite da consulta",
      "recordType": "Tipo do registro",
      "plannedStart": "Início planejado",
      "plannedEnd": "Fim planejado",
      "team": "Equipe",
      "availability": "Disponibilidade na data"
    }
  }
}
